import Fonts from "../assets/Fonts";

const themes = {
  theme1: {
    bg: `${process.env.REACT_APP_THEMES_URL}/bg1.jpg`,
    ft: `${process.env.REACT_APP_THEMES_URL}/ft1.png`,
    fb: `${process.env.REACT_APP_THEMES_URL}/fb1.png`,
    fc: '',
    ftStyle: `absolute top-0 right-0 md:w-1/3 sm:w-1/2 w-2/3`,
    fbStyle: `absolute bottom-0 left-0 md:w-1/3 sm:w-1/2 w-2/3`,
    fcStyle: `text-center p-20 md:w-1/2 sm:w-2/3 w-full text-black space-y-8`,
    tStyle: `text-center p-10 md:px-20 md:py-10 border border-gray-700`,
    xTopStyle: 100,
    xBottomStyle: -100,
    themeColor: 'bg-[#FFF7F2]',
    cd1: "bg-red-200 p-4 rounded-lg",
    cd2: "bg-red-300 p-4 rounded-lg",
    cd3: "bg-red-400 p-4 rounded-lg",
    cd4: "bg-red-500 p-4 rounded-lg",
    H2: Fonts.f1.H2,
    H2size: "text-5xl",
    fontP: Fonts.f1.fontP,
    ftPdf: `absolute top-0 right-0 w-1/2`,
    fbPdf: `absolute bottom-0 left-0 w-1/2`,
    fcPdf: `text-center p-4 w-full text-black space-y-6 z-10`,
    H2Pdf: "text-4xl",
    whiteBg: "p-2 mx-4 bg-white opacity-80 z-10 rounded-lg",
  },
  theme2: {
    bg: `${process.env.REACT_APP_THEMES_URL}/bg2.jpg`,
    ft: `${process.env.REACT_APP_THEMES_URL}/ft2.png`,
    fb: `${process.env.REACT_APP_THEMES_URL}/fb2.png`,
    fc: '',
    ftStyle: `absolute top-0 right-0 sm:w-2/3 md:w-2/5 w-full`,
    fbStyle: `absolute bottom-0 left-0 sm:w-2/3 md:w-2/5 w-full`,
    fcStyle: `text-center p-20 md:w-1/2 sm:w-2/3 w-full text-black space-y-8`,
    tStyle: `text-center p-10 md:px-20 md:py-10 border border-gray-700`,
    xTopStyle: 100,
    xBottomStyle: -100,
    themeColor: 'bg-[#F4F9F5]',
    cd1: "bg-green-200 p-4 rounded-lg",
    cd2: "bg-green-300 p-4 rounded-lg",
    cd3: "bg-green-400 p-4 rounded-lg",
    cd4: "bg-green-500 p-4 rounded-lg",
    H2: Fonts.f13.H2,
    H2size: "text-6xl",
    fontP: Fonts.f1.fontP,
    ftPdf: `absolute top-0 right-0 w-2/3 z-0`,
    fbPdf: `absolute bottom-0 left-0 w-2/3 z-0`,
    fcPdf: `text-center p-4 w-1/2 text-black space-y-8`,
    H2Pdf: "text-4xl",
    whiteBg: "p-2 mx-4 bg-white opacity-80 z-10 rounded-lg",
  },
  theme3: {
    bg: `${process.env.REACT_APP_THEMES_URL}/bg3.jpg`,
    ft: `${process.env.REACT_APP_THEMES_URL}/ft3.png`,
    fb: `${process.env.REACT_APP_THEMES_URL}/fb3.png`,
    fc: '',
    ftStyle: `absolute top-0 right-0 sm:w-1/3 md:w-1/5 w-1/3`,
    fbStyle: `absolute bottom-0 left-0 sm:w-2/3 md:w-2/5 w-full`,
    fcStyle: `text-center z-30 p-20 md:w-1/2 sm:w-2/3 w-full text-black space-y-8`,
    tStyle: `text-center p-10 md:px-20 md:py-10 border border-gray-700`,
    xTopStyle: 100,
    xBottomStyle: -100,
    themeColor: 'bg-[#EAF3EC]',
    cd1: "bg-green-200 p-4 rounded-lg",
    cd2: "bg-green-300 p-4 rounded-lg",
    cd3: "bg-green-400 p-4 rounded-lg",
    cd4: "bg-green-500 p-4 rounded-lg",
    H2: Fonts.f2.H2,
    H2size: "text-6xl",
    fontP: Fonts.f2.fontP,
    ftPdf: `absolute top-0 right-0 w-1/3`,
    fbPdf: `absolute bottom-0 left-0 w-3/4`,
    fcPdf: `text-center p-4 w-1/2 text-black space-y-8`,
    H2Pdf: "text-4xl",
    whiteBg: "p-2 mx-4 bg-white opacity-80 z-10 rounded-lg",
  },
  theme4: {
    bg: `${process.env.REACT_APP_THEMES_URL}/bg4.jpg`,
    ft: `${process.env.REACT_APP_THEMES_URL}/ft4.png`,
    fb: `${process.env.REACT_APP_THEMES_URL}/fb4.png`,
    fc: '',
    ftStyle: `absolute top-0 left-0 sm:w-3/5 md:w-2/5 w-4/5`,
    fbStyle: `absolute bottom-0 right-0 sm:w-2/5 md:w-1/3 w-2/3`,
    fcStyle: `text-center p-20 md:w-1/2 sm:w-2/3 w-full text-black space-y-8`,
    tStyle: `text-center p-10 md:px-20 md:py-10 border border-gray-700`,
    xTopStyle: -100,
    xBottomStyle: 100,
    themeColor: 'bg-gray-100',
    cd1: "bg-gray-200 p-4 rounded-lg",
    cd2: "bg-gray-300 p-4 rounded-lg",
    cd3: "bg-gray-400 p-4 rounded-lg",
    cd4: "bg-gray-500 p-4 rounded-lg",
    H2: Fonts.f7.H2,
    H2size: "text-5xl",
    fontP: Fonts.f1.fontP,
    ftPdf: `absolute top-0 left-0 sm:w-2/3 md:w-2/5 w-4/5`,
    fbPdf: `absolute bottom-0 right-0 sm:w-2/5 md:w-1/3 w-2/3`,
    fcPdf: `text-center p-8 w-full text-black space-y-8`,
    H2Pdf: "text-4xl",
    whiteBg: "p-2 mx-4 bg-white opacity-80 z-10 rounded-lg",
  },
  theme5: {
    bg: `${process.env.REACT_APP_THEMES_URL}/bg5.jpg`,
    ft: `${process.env.REACT_APP_THEMES_URL}/ft5.png`,
    fb: `${process.env.REACT_APP_THEMES_URL}/fb5.png`,
    fc: '',
    ftStyle: `absolute top-0 right-0 sm:w-1/3 md:w-1/4 w-2/5`,
    fbStyle: `absolute bottom-0 left-0 sm:w-1/3 md:w-1/4 w-2/5`,
    fcStyle: `text-center p-20 md:w-1/2 sm:w-2/3 w-full text-black space-y-8`,
    tStyle: `text-center p-10 md:px-20 md:py-10 border border-gray-700`,
    xTopStyle: 100,
    xBottomStyle: -100,
    themeColor: 'bg-gray-100',
    cd1: "bg-gray-200 p-4 rounded-lg",
    cd2: "bg-gray-300 p-4 rounded-lg",
    cd3: "bg-gray-400 p-4 rounded-lg",
    cd4: "bg-gray-500 p-4 rounded-lg",
    H2: Fonts.f2.H2,
    H2size: "text-6xl",
    fontP: Fonts.f2.fontP,
    ftPdf: `absolute top-0 right-0 w-1/3`,
    fbPdf: `absolute bottom-0 left-0 w-1/3`,
    fcPdf: `text-center p-8 w-1/2 text-black space-y-8`,
    H2Pdf: "text-4xl",
    whiteBg: "p-2 mx-4 bg-white opacity-80 z-10 rounded-lg",
  },
  theme6: {
    bg: `${process.env.REACT_APP_THEMES_URL}/bg6.jpg`,
    ft: `${process.env.REACT_APP_THEMES_URL}/ft6.png`,
    fb: `${process.env.REACT_APP_THEMES_URL}/fb6.png`,
    fc: `${process.env.REACT_APP_THEMES_URL}/fc6.png`,
    ftStyle: `absolute top-0 right-0 sm:w-2/3 md:w-2/3 w-full`,
    fbStyle: `absolute bottom-0 left-0 sm:w-2/3 md:w-2/3 w-full`,
    fcStyle: `text-center p-20 md:w-1/2 sm:w-2/3 w-full text-black space-y-36 md:space-y-8`,
    tStyle: `text-center p-10 md:px-20 md:py-10 border border-gray-700`,
    xTopStyle: 100,
    xBottomStyle: -100,
    themeColor: 'bg-gray-100',
    cd1: "bg-gray-200 p-4 rounded-lg",
    cd2: "bg-gray-300 p-4 rounded-lg",
    cd3: "bg-gray-400 p-4 rounded-lg",
    cd4: "bg-gray-500 p-4 rounded-lg",
    H2: Fonts.f7.H2,
    H2size: "text-5xl",
    fontP: Fonts.f7.fontP,
    ftPdf: `absolute top-0 right-0 w-full`,
    fbPdf: `absolute bottom-0 left-0 w-full`,
    fcPdf: `text-center w-2/3 text-black space-y-20`,
    H2Pdf: "text-4xl",
    whiteBg: "p-2 mx-4 bg-white opacity-80 z-10 rounded-lg",
  },
  theme7: {
    bg: `${process.env.REACT_APP_THEMES_URL}/bg7.jpg`,
    ft: `${process.env.REACT_APP_THEMES_URL}/ft7.png`,
    fb: `${process.env.REACT_APP_THEMES_URL}/fb7.png`,
    fc: `${process.env.REACT_APP_THEMES_URL}/fc7.png`,
    ftStyle: `absolute top-0 left-0 sm:w-2/3 md:w-1/3 w-3/5`,
    fbStyle: `absolute bottom-0 right-0 sm:w-2/3 md:w-1/3 w-3/5`,
    fcStyle: `text-center p-20 md:w-1/2 sm:w-2/3 w-full text-black space-y-36 md:space-y-8`,
    tStyle: `text-center p-10 md:px-20 md:py-10 border border-gray-700`,
    xTopStyle: -100,
    xBottomStyle: 100,
    themeColor: 'bg-gray-100',
    cd1: "bg-gray-200 p-4 rounded-lg",
    cd2: "bg-gray-300 p-4 rounded-lg",
    cd3: "bg-gray-400 p-4 rounded-lg",
    cd4: "bg-gray-500 p-4 rounded-lg",
    H2: Fonts.f9.H2,
    H2size: "text-6xl",
    fontP: Fonts.f1.fontP,
    ftPdf: `absolute top-0 left-0 w-3/5`,
    fbPdf: `absolute bottom-0 right-0 w-3/5`,
    fcPdf: `text-center p-8 w-2/3 text-black space-y-20`,
    H2Pdf: "text-4xl",
    whiteBg: "p-2 mx-4 bg-white opacity-80 z-10 rounded-lg",
  },
  theme8: {
    bg: `${process.env.REACT_APP_THEMES_URL}/bg8.jpg`,
    ft: `${process.env.REACT_APP_THEMES_URL}/ft8.png`,
    fb: `${process.env.REACT_APP_THEMES_URL}/fb8.png`,
    fc: '',
    ftStyle: `absolute top-0 left-0 sm:w-2/3 md:w-1/3 w-3/4`,
    fbStyle: `absolute bottom-0 right-0 sm:w-2/3 md:w-1/3 w-3/4`,
    fcStyle: `text-center p-20 md:w-1/2 sm:w-2/3 w-full text-black space-y-8`,
    tStyle: `text-center p-10 md:px-20 md:py-10 border border-gray-700`,
    xTopStyle: -100,
    xBottomStyle: 100,
    themeColor: 'bg-gray-100',
    cd1: "bg-gray-200 p-4 rounded-lg",
    cd2: "bg-gray-300 p-4 rounded-lg",
    cd3: "bg-gray-400 p-4 rounded-lg",
    cd4: "bg-gray-500 p-4 rounded-lg",
    H2: Fonts.f13.H2,
    H2size: "text-6xl",
    fontP: Fonts.f1.fontP,
    ftPdf: `absolute top-0 left-0 w-2/3`,
    fbPdf: `absolute bottom-0 right-0 w-2/3`,
    fcPdf: `text-center p-8 w-2/3 text-black space-y-8`,
    H2Pdf: "text-4xl",
    whiteBg: "p-2 mx-4 bg-white opacity-80 z-10 rounded-lg",
  },
  theme9: {
    bg: `${process.env.REACT_APP_THEMES_URL}/bg9.jpg`,
    ft: '',
    fb: '',
    fc: `${process.env.REACT_APP_THEMES_URL}/fc9.png`,
    ftStyle: `absolute top-0 left-0 sm:w-2/3 md:w-1/3 w-3/5`,
    fbStyle: `absolute bottom-0 right-0 sm:w-2/3 md:w-1/3 w-3/5`,
    fcStyle: `text-center p-20 md:w-1/2 sm:w-2/3 w-full text-black space-y-20 md:space-y-8`,
    tStyle: `text-center p-10 md:px-20 md:py-10 border border-gray-700`,
    xTopStyle: '',
    xBottomStyle: '',
    cd1: "bg-gray-200 p-4 rounded-lg",
    cd2: "bg-gray-300 p-4 rounded-lg",
    cd3: "bg-gray-400 p-4 rounded-lg",
    cd4: "bg-gray-500 p-4 rounded-lg",
    H2: Fonts.f7.H2,
    H2size: "text-5xl",
    fontP: Fonts.f2.fontP,
    ftPdf: `absolute top-0 left-0 w-3/5`,
    fbPdf: `absolute bottom-0 right-0 w-3/5`,
    fcPdf: `text-center p-8 w-full text-black space-y-20`,
    H2Pdf: "text-4xl",
    whiteBg: "p-2 mx-4 bg-white opacity-80 z-10 rounded-lg",
  },
  theme10: {
    bg: `${process.env.REACT_APP_THEMES_URL}/bg10.jpg`,
    ft: '',
    fb: '',
    fc: `${process.env.REACT_APP_THEMES_URL}/fc10.png`,
    ftStyle: `absolute top-0 right-0 sm:w-2/3 md:w-2/3 w-full`,
    fbStyle: `absolute bottom-0 left-0 sm:w-2/3 md:w-2/3 w-full`,
    fcStyle: `text-center p-20 md:p-40 md:w-1/2 sm:w-2/3 w-full text-black space-y-40 md:space-y-8`,
    tStyle: `text-center p-10 md:px-20 md:py-10 border border-gray-700`,
    xTopStyle: '',
    xBottomStyle: '',
    themeColor: 'bg-gray-100',
    cd1: "bg-green-200 p-4 rounded-lg",
    cd2: "bg-green-300 p-4 rounded-lg",
    cd3: "bg-green-400 p-4 rounded-lg",
    cd4: "bg-green-500 p-4 rounded-lg",
    H2: Fonts.f7.H2,
    H2size: "text-5xl",
    fontP: Fonts.f7.fontP,
    ftPdf: `absolute top-0 right-0 sm:w-2/3 md:w-2/3 w-full`,
    fbPdf: `absolute bottom-0 left-0 sm:w-2/3 md:w-2/3 w-full`,
    fcPdf: `text-center p-8 w-3/4 text-black space-y-32`,
    H2Pdf: "text-4xl",
    whiteBg: "p-2 mx-4 bg-white opacity-80 z-10 rounded-lg",
  },
  theme11: {
    bg: `${process.env.REACT_APP_THEMES_URL}/bg11.jpg`,
    ft: `${process.env.REACT_APP_THEMES_URL}/ft11.png`,
    fb: `${process.env.REACT_APP_THEMES_URL}/fb11.png`,
    fc: `${process.env.REACT_APP_THEMES_URL}/fc11.png`,
    ftStyle: `absolute top-0 right-0 sm:w-2/3 md:w-1/4 w-2/3`,
    fbStyle: `absolute bottom-0 left-0 sm:w-2/3 md:w-1/4 w-2/3`,
    fcStyle: `text-center p-20 md:p-40 md:w-1/2 sm:w-2/3 w-full text-neutral-50 space-y-32 md:space-y-8`,
    tStyle: `text-center text-neutral-50 p-10 md:px-20 md:py-10 border border-yellow-200`,
    xTopStyle: 100,
    xBottomStyle: -100,
    textColor: `text-neutral-50`,
    themeColor: 'bg-slate-900',
    cd1: "bg-yellow-100 p-4 rounded-lg",
    cd2: "bg-yellow-200 p-4 rounded-lg",
    cd3: "bg-yellow-300 p-4 rounded-lg",
    cd4: "bg-yellow-400 p-4 rounded-lg",
    H2: Fonts.f2.H2,
    H2size: "text-5xl",
    fontP: Fonts.f2.fontP,
    ftPdf: `absolute top-0 right-0 w-1/2`,
    fbPdf: `absolute bottom-0 left-0 w-1/2`,
    fcPdf: `text-center p-8 w-3/4 text-textcolor space-y-20`,
    H2Pdf: "text-4xl",
    whiteBg: "p-2 mx-4 bg-white opacity-80 z-10 rounded-lg",
  },
  theme12: {
    bg: `${process.env.REACT_APP_THEMES_URL}/bg12.jpg`,
    ft: '',
    fb: '',
    fc: `${process.env.REACT_APP_THEMES_URL}/fc12.png`,
    ftStyle: `absolute top-0 right-0 sm:w-2/3 md:w-2/3 w-full`,
    fbStyle: `absolute bottom-0 left-0 sm:w-2/3 md:w-2/3 w-full`,
    fcStyle: `text-center p-20 md:p-56 md:w-1/2 sm:w-2/3 w-full text-black space-y-36 md:space-y-8`,
    tStyle: `text-center p-10 md:px-20 md:py-10 bg-white shadow-lg`,
    xTopStyle: '',
    xBottomStyle: '',
    themeColor: 'bg-red-100',
    cd1: "bg-red-200 p-4 rounded-lg",
    cd2: "bg-red-300 p-4 rounded-lg",
    cd3: "bg-red-400 p-4 rounded-lg",
    cd4: "bg-red-500 p-4 rounded-lg",
    H2: Fonts.f7.H2,
    H2size: "text-4xl",
    fontP: Fonts.f7.fontP,
    ftPdf: `absolute top-0 right-0 sm:w-2/3 md:w-2/3 w-full`,
    fbPdf: `absolute bottom-0 left-0 sm:w-2/3 md:w-2/3 w-full`,
    fcPdf: `text-center p-8 w-4/5 text-black space-y-32`,
    H2Pdf: "text-4xl",
    whiteBg: "p-2 mx-4 bg-white opacity-80 z-10 rounded-lg",
  },
  theme13: {
    bg: `${process.env.REACT_APP_THEMES_URL}/bg13.jpg`,
    ft: `${process.env.REACT_APP_THEMES_URL}/ft13.png`,
    fb: `${process.env.REACT_APP_THEMES_URL}/fb13.png`,
    fc: '',
    ftStyle: `absolute top-0 right-0 sm:w-2/3 md:w-1/3 w-3/5`,
    fbStyle: `absolute bottom-0 left-0 sm:w-2/3 md:w-1/3 w-3/5`,
    fcStyle: `text-center p-20 md:w-1/2 sm:w-2/3 w-full text-blue-100 space-y-8 md:space-y-8`,
    tStyle: `text-center p-10 md:px-20 md:py-10 text-blue-100 border border-blue-200`,
    xTopStyle: 100,
    xBottomStyle: -100,
    textColor: `text-blue-100`,
    themeColor: 'bg-cyan-950',
    cd1: "bg-blue-200 p-4 rounded-lg",
    cd2: "bg-blue-300 p-4 rounded-lg",
    cd3: "bg-blue-400 p-4 rounded-lg",
    cd4: "bg-blue-500 p-4 rounded-lg",
    H2: Fonts.f7.H2,
    H2size: "text-5xl",
    fontP: Fonts.f7.fontP,
    ftPdf: `absolute top-0 right-0 w-3/5`,
    fbPdf: `absolute bottom-0 left-0 w-3/5`,
    fcPdf: `text-center p-8 w-1/2 text-blue-100 space-y-8`,
    H2Pdf: "text-4xl",
    whiteBg: "p-2 mx-4 bg-cyan-950 opacity-80 z-10 rounded-lg",
  },
  theme14: {
    bg: `${process.env.REACT_APP_THEMES_URL}/bg14.jpg`,
    ft: `${process.env.REACT_APP_THEMES_URL}/ft14.png`,
    fb: `${process.env.REACT_APP_THEMES_URL}/fb14.png`,
    fc: `${process.env.REACT_APP_THEMES_URL}/fc14.png`,
    ftStyle: `absolute top-0 right-0 sm:w-2/3 md:w-1/4 w-1/2`,
    fbStyle: `absolute bottom-0 left-0 sm:w-2/3 md:w-1/4 w-1/2`,
    fcStyle: `text-center p-20 md:p-40 md:w-1/2 sm:w-2/3 w-full text-black space-y-44 md:space-y-8`,
    tStyle: `text-center text-black p-10 md:px-20 md:py-10 border border-purple-300`,
    xTopStyle: 100,
    xBottomStyle: -100,
    themeColor: 'bg-blue-100',
    cd1: "bg-blue-200 p-4 rounded-lg",
    cd2: "bg-blue-300 p-4 rounded-lg",
    cd3: "bg-blue-400 p-4 rounded-lg",
    cd4: "bg-blue-500 p-4 rounded-lg",
    H2: Fonts.f18.H2,
    H2size: "text-6xl",
    fontP: Fonts.f2.fontP,
    ftPdf: `absolute top-0 right-0 w-1/2`,
    fbPdf: `absolute bottom-0 left-0 w-1/2`,
    fcPdf: `text-center p-8 w-3/4 text-black space-y-32`,
    H2Pdf: "text-4xl",
    whiteBg: "p-2 mx-4 bg-white opacity-80 z-10 rounded-lg",
  },
  theme15: {
    bg: `${process.env.REACT_APP_THEMES_URL}/bg15.jpg`,
    ft: '',
    fb: '',
    fc: `${process.env.REACT_APP_THEMES_URL}/fc15.png`,
    ftStyle: `absolute top-0 right-0 sm:w-2/3 md:w-1/4 w-1/2`,
    fbStyle: `absolute bottom-0 left-0 sm:w-2/3 md:w-1/4 w-1/2`,
    fcStyle: `text-center p-20 md:p-40 md:w-1/2 sm:w-2/3 w-full text-black space-y-44 md:space-y-8`,
    tStyle: `text-center text-black p-10 md:px-20 md:py-10 border border-red-400`,
    xTopStyle: '',
    xBottomStyle: '',
    themeColor: 'bg-gray-100',
    cd1: "bg-gray-200 p-4 rounded-lg",
    cd2: "bg-gray-300 p-4 rounded-lg",
    cd3: "bg-gray-400 p-4 rounded-lg",
    cd4: "bg-gray-500 p-4 rounded-lg",
    H2: Fonts.f1.H2,
    H2size: "text-5xl",
    fontP: Fonts.f7.fontP,
    ftPdf: `absolute top-0 right-0 sm:w-2/3 md:w-1/4 w-1/2`,
    fbPdf: `absolute bottom-0 left-0 sm:w-2/3 md:w-1/4 w-1/2`,
    fcPdf: `text-center p-8 w-3/4 text-black space-y-32`,
    H2Pdf: "text-4xl",
    whiteBg: "p-2 mx-4 bg-white opacity-80 z-10 rounded-lg",
  },
  theme16: {
    bg: `${process.env.REACT_APP_THEMES_URL}/bg16.jpg`,
    ft: '',
    fb: '',
    fc: `${process.env.REACT_APP_THEMES_URL}/fc16.png`,
    ftStyle: `absolute top-0 right-0 sm:w-2/3 md:w-1/4 w-1/2`,
    fbStyle: `absolute bottom-0 left-0 sm:w-2/3 md:w-1/4 w-1/2`,
    fcStyle: `text-center p-20 md:p-40 md:w-1/2 sm:w-2/3 w-full text-black space-y-40 md:space-y-4`,
    tStyle: `text-center text-black p-10 md:px-20 md:py-10 border border-gray-600`,
    xTopStyle: '',
    xBottomStyle: '',
    textColor: `text-black`,
    themeColor: 'bg-gray-100',
    cd1: "bg-gray-200 p-4 rounded-lg",
    cd2: "bg-gray-300 p-4 rounded-lg",
    cd3: "bg-gray-400 p-4 rounded-lg",
    cd4: "bg-gray-500 p-4 rounded-lg",
    H2: Fonts.f2.H2,
    H2size: "text-5xl",
    fontP: Fonts.f2.fontP,
    ftPdf: `absolute top-0 right-0 sm:w-2/3 md:w-1/4 w-1/2`,
    fbPdf: `absolute bottom-0 left-0 sm:w-2/3 md:w-1/4 w-1/2`,
    fcPdf: `text-center p-8 w-4/5 text-black space-y-32`,
    H2Pdf: "text-4xl",
    whiteBg: "p-2 mx-4 bg-white opacity-80 z-10 rounded-lg",
  },
  theme17: {
    bg: `${process.env.REACT_APP_THEMES_URL}/bg17.jpg`,
    ft: '',
    fb: '',
    fc: `${process.env.REACT_APP_THEMES_URL}/fc17.png`,
    ftStyle: `absolute top-0 right-0 sm:w-2/3 md:w-1/4 w-1/2`,
    fbStyle: `absolute bottom-0 left-0 sm:w-2/3 md:w-1/4 w-1/2`,
    fcStyle: `text-center p-20 md:p-52 md:w-1/2 sm:w-2/3 w-full text-yellow-100 space-y-52 md:space-y-8`,
    tStyle: `text-center text-yellow-100 p-10 md:px-20 md:py-10 border border-yellow-100`,
    xTopStyle: '',
    xBottomStyle: '',
    textColor: `text-yellow-100`,
    themeColor: 'bg-gray-800',
    cd1: "bg-yellow-100 p-4 rounded-lg",
    cd2: "bg-yellow-200 p-4 rounded-lg",
    cd3: "bg-yellow-300 p-4 rounded-lg",
    cd4: "bg-yellow-400 p-4 rounded-lg",
    H2: Fonts.f2.H2,
    H2size: "text-5xl",
    fontP: Fonts.f2.fontP,
    ftPdf: `absolute top-0 right-0 sm:w-2/3 md:w-1/4 w-1/2`,
    fbPdf: `absolute bottom-0 left-0 sm:w-2/3 md:w-1/4 w-1/2`,
    fcPdf: `text-center p-32 w-full h-full flex flex-col items-center justify-center text-yellow-100 space-y-8`,
    H2Pdf: "text-4xl",
    whiteBg: "p-2 mx-4 bg-gray-800 opacity-80 z-10 rounded-lg",
  },
  theme18: {
    bg: `${process.env.REACT_APP_THEMES_URL}/bg18.jpg`,
    ft: `${process.env.REACT_APP_THEMES_URL}/ft18.png`,
    fb: `${process.env.REACT_APP_THEMES_URL}/fb18.png`,
    fc: '',
    ftStyle: `absolute top-0 left-0 sm:w-2/3 md:w-1/4 w-4/5`,
    fbStyle: `absolute bottom-0 right-0 sm:w-2/3 md:w-1/4 w-4/5`,
    fcStyle: `text-center p-20 md:p-40 md:w-1/2 sm:w-2/3 w-full text-black space-y-8 md:space-y-8`,
    tStyle: `text-center text-black p-10 md:px-20 md:py-10 border border-gray-600`,
    xTopStyle: -100,
    xBottomStyle: 100,
    textColor: `text-black`,
    themeColor: 'bg-pink-100',
    cd1: "bg-pink-200 p-4 rounded-lg",
    cd2: "bg-pink-300 p-4 rounded-lg",
    cd3: "bg-pink-400 p-4 rounded-lg",
    cd4: "bg-pink-500 p-4 rounded-lg",
    H2: Fonts.f9.H2,
    H2size: "text-6xl",
    fontP: Fonts.f7.fontP,
    ftPdf: `absolute top-0 left-0 w-3/4`,
    fbPdf: `absolute bottom-0 right-0 w-3/4`,
    fcPdf: `text-center p-8 w-full text-black space-y-8`,
    H2Pdf: "text-4xl",
    whiteBg: "p-2 mx-4 bg-white opacity-80 z-10 rounded-lg",
  },
  theme19: {
    bg: `${process.env.REACT_APP_THEMES_URL}/bg19.jpg`,
    ft: `${process.env.REACT_APP_THEMES_URL}/ft19.png`,
    fb: `${process.env.REACT_APP_THEMES_URL}/fb19.png`,
    fc: '',
    ftStyle: `absolute top-0 left-0 sm:w-2/3 md:w-1/5 w-1/2`,
    fbStyle: `absolute top-0 right-0 sm:w-2/3 md:w-1/5 w-1/2`,
    fcStyle: `text-center p-20 md:p-40 md:w-1/2 sm:w-2/3 w-full text-red-300 space-y-8 md:space-y-8`,
    tStyle: `text-center text-red-300 p-10 md:px-20 md:py-10 border border-red-300`,
    xTopStyle: -100,
    xBottomStyle: 100,
    textColor: `text-red-300`,
    themeColor: 'bg-gray-800',
    cd1: "bg-gray-200 p-4 rounded-lg",
    cd2: "bg-gray-300 p-4 rounded-lg",
    cd3: "bg-gray-400 p-4 rounded-lg",
    cd4: "bg-gray-500 p-4 rounded-lg",
    H2: Fonts.f7.H2,
    H2size: "text-5xl",
    fontP: Fonts.f7.fontP,
    ftPdf: `absolute top-0 left-0 w-2/5`,
    fbPdf: `absolute top-0 right-0 w-2/5`,
    fcPdf: `text-center p-8 w-full text-red-300 space-y-8`,
    H2Pdf: "text-4xl",
    fontP: Fonts.f7.fontP,
    whiteBg: "p-2 mx-4 bg-gray-800 opacity-80 z-10 rounded-lg",
  },
  theme20: {
    bg: `${process.env.REACT_APP_THEMES_URL}/bg20.jpg`,
    ft: '',
    fb: '',
    fc: `${process.env.REACT_APP_THEMES_URL}/fc20.png`,
    ftStyle: `absolute top-0 right-0 sm:w-2/3 md:w-2/3 w-full`,
    fbStyle: `absolute bottom-0 left-0 sm:w-2/3 md:w-2/3 w-full`,
    fcStyle: `text-center p-20 md:p-40 md:w-1/2 sm:w-2/3 w-full text-black space-y-52 md:space-y-8`,
    tStyle: `text-center p-10 md:px-20 md:py-10 border border-gray-700`,
    xTopStyle: '',
    xBottomStyle: '',
    themeColor: 'bg-blue-100',
    cd1: "bg-blue-200 p-4 rounded-lg",
    cd2: "bg-blue-300 p-4 rounded-lg",
    cd3: "bg-blue-400 p-4 rounded-lg",
    cd4: "bg-blue-500 p-4 rounded-lg",
    H2: Fonts.f1.H2,
    H2size: "text-5xl",
    fontP: Fonts.f7.fontP,
    ftPdf: `absolute top-0 right-0 sm:w-2/3 md:w-2/3 w-full`,
    fbPdf: `absolute bottom-0 left-0 sm:w-2/3 md:w-2/3 w-full`,
    fcPdf: `text-center p-32 w-full h-full flex flex-col items-center justify-center text-black space-y-8`,
    H2Pdf: "text-4xl",
    whiteBg: "p-2 mx-4 bg-white opacity-80 z-10 rounded-lg",
  },
  theme21: {
    bg: `${process.env.REACT_APP_THEMES_URL}/bg21.jpg`,
    ft: `${process.env.REACT_APP_THEMES_URL}/ft21.png`,
    fb: `${process.env.REACT_APP_THEMES_URL}/fb21.png`,
    fc: '',
    ftStyle: `absolute top-0 left-0 sm:w-3/5 md:w-2/5 w-4/5`,
    fbStyle: `absolute bottom-0 right-0 sm:w-2/5 md:w-1/6 w-1/3`,
    fcStyle: `text-center p-20 md:w-1/2 sm:w-2/3 w-full text-black space-y-8`,
    tStyle: `text-center p-10 md:px-20 md:py-10 border border-gray-700`,
    xTopStyle: -100,
    xBottomStyle: 100,
    themeColor: 'bg-gray-100',
    cd1: "bg-gray-200 p-4 rounded-lg",
    cd2: "bg-gray-300 p-4 rounded-lg",
    cd3: "bg-gray-400 p-4 rounded-lg",
    cd4: "bg-gray-500 p-4 rounded-lg",
    H2: Fonts.f2.H2,
    H2size: "text-6xl",
    fontP: Fonts.f2.fontP,
    ftPdf: `absolute top-0 left-0 w-3/4`,
    fbPdf: `absolute bottom-0 right-0 w-1/3`,
    fcPdf: `text-center p-8 w-full text-black space-y-8`,
    H2Pdf: "text-4xl",
    whiteBg: "p-2 mx-4 bg-white opacity-80 z-10 rounded-lg",
  },
  theme22: {
    bg: `${process.env.REACT_APP_THEMES_URL}/bg22.jpg`,
    ft: '',
    fb: '',
    fc: `${process.env.REACT_APP_THEMES_URL}/fc22.png`,
    ftStyle: `absolute top-0 right-0 sm:w-2/3 md:w-2/3 w-full`,
    fbStyle: `absolute bottom-0 left-0 sm:w-2/3 md:w-2/3 w-full`,
    fcStyle: `text-center p-20 md:p-40 md:w-1/2 sm:w-2/3 w-full text-black space-y-40 md:space-y-8`,
    tStyle: `text-center p-10 md:px-20 md:py-10 border border-gray-700`,
    xTopStyle: '',
    xBottomStyle: '',
    themeColor: 'bg-red-100',
    cd1: "bg-red-200 p-4 rounded-lg",
    cd2: "bg-red-300 p-4 rounded-lg",
    cd3: "bg-red-400 p-4 rounded-lg",
    cd4: "bg-red-500 p-4 rounded-lg",
    H2: Fonts.f7.H2,
    H2size: "text-5xl",
    fontP: Fonts.f7.fontP,
    ftPdf: `absolute top-0 right-0 sm:w-2/3 md:w-2/3 w-full`,
    fbPdf: `absolute bottom-0 left-0 sm:w-2/3 md:w-2/3 w-full`,
    fcPdf: `text-center p-8 w-3/4 text-black space-y-28`,
    H2Pdf: "text-4xl",
    whiteBg: "p-2 mx-4 bg-white opacity-80 z-10 rounded-lg",
  },
  theme23: {
    bg: `${process.env.REACT_APP_THEMES_URL}/bg15.jpg`,
    ft: `${process.env.REACT_APP_THEMES_URL}/ft23.png`,
    fb: `${process.env.REACT_APP_THEMES_URL}/fb23.png`,
    fc: '',
    ftStyle: `absolute top-0 left-0 sm:w-3/5 md:w-1/6 w-2/5`,
    fbStyle: `absolute bottom-0 right-0 sm:w-2/5 md:w-1/6 w-2/5`,
    fcStyle: `text-center p-20 md:w-1/2 sm:w-2/3 w-full text-black space-y-8`,
    tStyle: `text-center p-10 md:px-20 md:py-10 border border-gray-700`,
    xTopStyle: -100,
    xBottomStyle: 100,
    themeColor: 'bg-blue-100',
    cd1: "bg-blue-200 p-4 rounded-lg",
    cd2: "bg-blue-300 p-4 rounded-lg",
    cd3: "bg-blue-400 p-4 rounded-lg",
    cd4: "bg-blue-500 p-4 rounded-lg",
    H2: Fonts.f2.H2,
    H2size: "text-6xl",
    fontP: Fonts.f2.fontP,
    ftPdf: `absolute top-0 left-0 w-2/5`,
    fbPdf: `absolute bottom-0 right-0 w-2/5`,
    fcPdf: `text-center p-8 w-1/2 text-black space-y-8`,
    H2Pdf: "text-4xl",
    whiteBg: "p-2 mx-4 bg-white opacity-80 z-10 rounded-lg",
  },
  theme24: {
    bg: `${process.env.REACT_APP_THEMES_URL}/bg24.jpg`,
    ft: `${process.env.REACT_APP_THEMES_URL}/ft24.png`,
    fb: `${process.env.REACT_APP_THEMES_URL}/fb24.png`,
    fc: '',
    ftStyle: `absolute top-0 left-0 sm:w-3/5 md:w-1/2 w-3/4`,
    fbStyle: `absolute bottom-0 right-0 sm:w-2/5 md:w-1/6 w-2/5`,
    fcStyle: `text-center p-20 md:w-1/2 sm:w-2/3 w-full text-black space-y-8`,
    tStyle: `text-center p-10 md:px-20 md:py-10 border border-gray-700`,
    xTopStyle: -100,
    xBottomStyle: 100,
    cd1: "bg-pink-200 p-4 rounded-lg",
    cd2: "bg-pink-300 p-4 rounded-lg",
    cd3: "bg-pink-400 p-4 rounded-lg",
    cd4: "bg-pink-500 p-4 rounded-lg",
    H2: Fonts.f13.H2,
    H2size: "text-6xl",
    fontP: Fonts.f1.fontP,
    ftPdf: `absolute top-0 left-0 w-3/4`,
    fbPdf: `absolute bottom-0 right-0 w-2/5`,
    fcPdf: `text-center p-8 w-1/2 text-black space-y-8`,
    H2Pdf: "text-4xl",
    whiteBg: "p-2 mx-4 bg-white opacity-80 z-10 rounded-lg",
  },
  theme25: {
    bg: `${process.env.REACT_APP_THEMES_URL}/bg25.jpg`,
    ft: `${process.env.REACT_APP_THEMES_URL}/ft25.png`,
    fb: `${process.env.REACT_APP_THEMES_URL}/fb25.png`,
    fc: '',
    ftStyle: `absolute top-0 left-0 sm:w-3/5 md:w-1/5 w-2/5`,
    fbStyle: `absolute bottom-0 right-0 sm:w-2/5 md:w-1/6 w-2/5`,
    fcStyle: `text-center p-20 md:w-1/2 sm:w-2/3 w-full text-black space-y-8`,
    tStyle: `text-center p-10 md:px-20 md:py-10 border border-gray-700`,
    xTopStyle: -100,
    xBottomStyle: 100,
    themeColor: 'bg-purple-100',
    cd1: "bg-purple-200 p-4 rounded-lg",
    cd2: "bg-purple-300 p-4 rounded-lg",
    cd3: "bg-purple-400 p-4 rounded-lg",
    cd4: "bg-purple-500 p-4 rounded-lg",
    H2: Fonts.f2.H2,
    H2size: "text-6xl",
    fontP: Fonts.f2.fontP,
    ftPdf: `absolute top-0 left-0 w-1/3`,
    fbPdf: `absolute bottom-0 right-0 w-1/3`,
    fcPdf: `text-center p-8 w-full text-black space-y-8`,
    H2Pdf: "text-4xl",
    whiteBg: "p-2 mx-4 bg-white opacity-80 z-10 rounded-lg",
  },
  theme26: {
    bg: `${process.env.REACT_APP_THEMES_URL}/bg26.jpg`,
    ft: `${process.env.REACT_APP_THEMES_URL}/ft26.png`,
    fb: `${process.env.REACT_APP_THEMES_URL}/fb26.png`,
    fc: '',
    ftStyle: `absolute top-0 left-0 sm:w-3/5 md:w-1/4 w-3/5`,
    fbStyle: `absolute bottom-0 right-0 sm:w-2/5 md:w-1/4 w-3/5`,
    fcStyle: `text-center p-20 md:w-1/2 sm:w-2/3 w-full text-black space-y-8`,
    tStyle: `text-center p-10 md:px-20 md:py-10 border border-gray-700`,
    xTopStyle: -100,
    xBottomStyle: 100,
    themeColor: 'bg-white',
    cd1: "bg-purple-200 p-4 rounded-lg",
    cd2: "bg-purple-300 p-4 rounded-lg",
    cd3: "bg-purple-400 p-4 rounded-lg",
    cd4: "bg-purple-500 p-4 rounded-lg",
    H2: Fonts.f2.H2,
    H2size: "text-6xl",
    fontP: Fonts.f2.fontP,
    ftPdf: `absolute top-0 left-0 w-1/2`,
    fbPdf: `absolute bottom-0 right-0 w-1/2`,
    fcPdf: `text-center p-8 w-full text-black space-y-8`,
    H2Pdf: "text-4xl",
    whiteBg: "p-2 mx-4 bg-white opacity-80 z-10 rounded-lg",
  },
  theme27: {
    bg: `${process.env.REACT_APP_THEMES_URL}/bg27.jpg`,
    ft: `${process.env.REACT_APP_THEMES_URL}/ft27.png`,
    fb: `${process.env.REACT_APP_THEMES_URL}/fb27.png`,
    fc: '',
    ftStyle: `absolute top-0 right-0 md:w-1/6 sm:w-1/2 w-1/3`,
    fbStyle: `absolute bottom-0 left-0 md:w-1/5 sm:w-1/2 w-1/2`,
    fcStyle: `text-center p-20 md:w-1/2 sm:w-2/3 w-full text-black space-y-8`,
    tStyle: `text-center p-10 md:px-20 md:py-10 border border-gray-700`,
    xTopStyle: 100,
    xBottomStyle: -100,
    themeColor: 'bg-purple-100',
    cd1: "bg-purple-200 p-4 rounded-lg",
    cd2: "bg-purple-300 p-4 rounded-lg",
    cd3: "bg-purple-400 p-4 rounded-lg",
    cd4: "bg-purple-500 p-4 rounded-lg",
    H2: Fonts.f1.H2,
    H2size: "text-5xl",
    fontP: Fonts.f1.fontP,
    ftPdf: `absolute top-0 right-0 w-1/4`,
    fbPdf: `absolute bottom-0 left-0 w-1/3`,
    fcPdf: `text-center p-8 w-full text-black space-y-8`,
    H2Pdf: "text-4xl",
    whiteBg: "p-2 mx-4 bg-white opacity-80 z-10 rounded-lg",
  },
  theme28: {
    bg: `${process.env.REACT_APP_THEMES_URL}/bg28.jpg`,
    ft: '',
    fb: '',
    fc: `${process.env.REACT_APP_THEMES_URL}/fc28.png`,
    ftStyle: `absolute top-0 right-0 sm:w-2/3 md:w-2/3 w-full`,
    fbStyle: `absolute bottom-0 left-0 sm:w-2/3 md:w-2/3 w-full`,
    fcStyle: `text-center p-20 md:p-44 md:w-1/2 sm:w-2/3 w-full text-black space-y-40 md:space-y-8`,
    tStyle: `text-center p-10 md:px-20 md:py-10 border border-gray-700`,
    xTopStyle: '',
    xBottomStyle: '',
    themeColor: 'bg-[#dfdad7]',
    cd1: "bg-gray-200 p-4 rounded-lg",
    cd2: "bg-gray-300 p-4 rounded-lg",
    cd3: "bg-gray-400 p-4 rounded-lg",
    cd4: "bg-gray-500 p-4 rounded-lg",
    H2: Fonts.f7.H2,
    H2size: "text-5xl",
    fontP: Fonts.f7.fontP,
    ftPdf: `absolute top-0 right-0 w-full`,
    fbPdf: `absolute bottom-0 left-0 w-full`,
    fcPdf: `text-center p-8 w-4/5 text-black space-y-32`,
    H2Pdf: "text-4xl",
    whiteBg: "p-2 mx-4 bg-white opacity-80 z-10 rounded-lg",
  },
  theme29: {
    bg: `${process.env.REACT_APP_THEMES_URL}/bg29.jpg`,
    ft: `${process.env.REACT_APP_THEMES_URL}/ft29.png`,
    fb: `${process.env.REACT_APP_THEMES_URL}/fb29.png`,
    fc: `${process.env.REACT_APP_THEMES_URL}/fc29.png`,
    ftStyle: `absolute top-0 right-0 sm:w-2/3 md:w-1/4 w-3/5`,
    fbStyle: `absolute bottom-0 left-0 sm:w-2/3 md:w-1/4 w-3/5`,
    fcStyle: `text-center p-20 md:w-1/2 sm:w-2/3 w-full text-black space-y-36 md:space-y-8`,
    tStyle: `text-center p-10 md:px-20 md:py-10 border border-gray-700`,
    xTopStyle: 100,
    xBottomStyle: -100,
    themeColor: 'bg-pink-100',
    cd1: "bg-pink-200 p-4 rounded-lg",
    cd2: "bg-pink-300 p-4 rounded-lg",
    cd3: "bg-pink-400 p-4 rounded-lg",
    cd4: "bg-pink-500 p-4 rounded-lg",
    H2: Fonts.f2.H2,
    H2size: "text-6xl",
    fontP: Fonts.f2.fontP,
    ftPdf: `absolute top-0 right-0 w-1/2`,
    fbPdf: `absolute bottom-0 left-0 w-1/2`,
    fcPdf: `text-center p-8 w-3/4 text-black space-y-28`,
    H2Pdf: "text-4xl",
    whiteBg: "p-2 mx-4 bg-white opacity-80 z-10 rounded-lg",
  },
  theme30: {
    bg: `${process.env.REACT_APP_THEMES_URL}/bg30.jpg`,
    ft: `${process.env.REACT_APP_THEMES_URL}/ft30.png`,
    fb: `${process.env.REACT_APP_THEMES_URL}/fb30.png`,
    fc: `${process.env.REACT_APP_THEMES_URL}/fc30.png`,
    ftStyle: `absolute top-0 right-0 sm:w-2/3 md:w-1/5 w-2/5`,
    fbStyle: `absolute bottom-0 left-0 sm:w-2/3 md:w-1/5 w-2/5`,
    fcStyle: `text-center p-20 md:w-1/2 sm:w-2/3 w-full text-black space-y-36 md:space-y-8`,
    tStyle: `text-center p-10 md:px-20 md:py-10 border border-gray-700`,
    xTopStyle: 100,
    xBottomStyle: -100,
    themeColor: 'bg-pink-100',
    cd1: "bg-pink-200 p-4 rounded-lg",
    cd2: "bg-pink-300 p-4 rounded-lg",
    cd3: "bg-pink-400 p-4 rounded-lg",
    cd4: "bg-pink-500 p-4 rounded-lg",
    H2: Fonts.f1.H2,
    H2size: "text-5xl",
    fontP: Fonts.f1.fontP,
    ftPdf: `absolute top-0 right-0 w-2/5`,
    fbPdf: `absolute bottom-0 left-0 w-2/5`,
    fcPdf: `text-center p-8 w-3/4 text-black space-y-28`,
    H2Pdf: "text-4xl",
    whiteBg: "p-2 mx-4 bg-white opacity-80 z-10 rounded-lg",
  },
  theme31: {
    bg: `${process.env.REACT_APP_THEMES_URL}/bg31.jpg`,
    ft: '',
    fb: '',
    fc: `${process.env.REACT_APP_THEMES_URL}/fc31.png`,
    ftStyle: `absolute top-0 right-0 sm:w-2/3 md:w-2/3 w-full`,
    fbStyle: `absolute bottom-0 left-0 sm:w-2/3 md:w-2/3 w-full`,
    fcStyle: `text-center p-20 md:p-44 md:w-1/2 sm:w-2/3 w-full text-black space-y-40 md:space-y-8`,
    tStyle: `text-center p-10 md:px-20 md:py-10 border border-gray-700`,
    xTopStyle: '',
    xBottomStyle: '',
    themeColor: 'bg-purple-100',
    cd1: "bg-purple-200 p-4 rounded-lg",
    cd2: "bg-purple-300 p-4 rounded-lg",
    cd3: "bg-purple-400 p-4 rounded-lg",
    cd4: "bg-purple-500 p-4 rounded-lg",
    H2: Fonts.f1.H2,
    H2size: "text-5xl",
    fontP: Fonts.f1.fontP,
    ftPdf: `absolute top-0 right-0 w-full`,
    fbPdf: `absolute bottom-0 left-0 w-full`,
    fcPdf: `text-center p-8 w-4/5 text-black space-y-32`,
    H2Pdf: "text-4xl",
    whiteBg: "p-2 mx-4 bg-white opacity-80 z-10 rounded-lg",
  },
  theme32: {
    bg: `${process.env.REACT_APP_THEMES_URL}/bg32.jpg`,
    ft: `${process.env.REACT_APP_THEMES_URL}/ft32.png`,
    fb: `${process.env.REACT_APP_THEMES_URL}/fb32.png`,
    fc: '',
    ftStyle: `absolute top-0 left-0 sm:w-3/5 md:w-1/4 w-1/2`,
    fbStyle: `absolute bottom-0 right-0 sm:w-2/5 md:w-1/4 w-1/2`,
    fcStyle: `text-center p-20 md:w-1/2 sm:w-2/3 w-full text-black space-y-8`,
    tStyle: `text-center p-10 md:px-20 md:py-10 border border-gray-700`,
    xTopStyle: -100,
    xBottomStyle: 100,
    themeColor: 'bg-purple-100',
    cd1: "bg-purple-200 p-4 rounded-lg",
    cd2: "bg-purple-300 p-4 rounded-lg",
    cd3: "bg-purple-400 p-4 rounded-lg",
    cd4: "bg-purple-500 p-4 rounded-lg",
    H2: Fonts.f2.H2,
    H2size: "text-6xl",
    fontP: Fonts.f2.fontP,
    ftPdf: `absolute top-0 left-0 w-2/5`,
    fbPdf: `absolute bottom-0 right-0 w-2/5`,
    fcPdf: `text-center p-8 w-full text-black space-y-8`,
    H2Pdf: "text-4xl",
    whiteBg: "p-2 mx-4 bg-white opacity-80 z-10 rounded-lg",
  },
  theme33: {
    bg: `${process.env.REACT_APP_THEMES_URL}/bg33.jpg`,
    ft: `${process.env.REACT_APP_THEMES_URL}/ft33.png`,
    fb: `${process.env.REACT_APP_THEMES_URL}/fb33.png`,
    fc: '',
    ftStyle: `absolute top-0 right-0 md:w-1/4 sm:w-1/2 w-1/2`,
    fbStyle: `absolute bottom-0 left-0 md:w-1/4 sm:w-1/2 w-1/2`,
    fcStyle: `text-center p-20 md:w-1/2 sm:w-2/3 w-full text-black space-y-8`,
    tStyle: `text-center p-10 md:px-20 md:py-10 border border-gray-700`,
    xTopStyle: 100,
    xBottomStyle: -100,
    themeColor: 'bg-pink-100',
    cd1: "bg-pink-200 p-4 rounded-lg",
    cd2: "bg-pink-300 p-4 rounded-lg",
    cd3: "bg-pink-400 p-4 rounded-lg",
    cd4: "bg-pink-500 p-4 rounded-lg",
    H2: Fonts.f2.H2,
    H2size: "text-6xl",
    fontP: Fonts.f2.fontP,
    ftPdf: `absolute top-0 right-0 w-1/2`,
    fbPdf: `absolute bottom-0 left-0 w-1/2`,
    fcPdf: `text-center p-8 w-full text-black space-y-8`,
    H2Pdf: "text-4xl",
    whiteBg: "p-2 mx-4 bg-white opacity-80 z-10 rounded-lg",
  },
  theme34: {
    bg: `${process.env.REACT_APP_THEMES_URL}/bg34.jpg`,
    ft: '',
    fb: '',
    fc: `${process.env.REACT_APP_THEMES_URL}/fc34.png`,
    ftStyle: `absolute top-0 right-0 sm:w-2/3 md:w-2/3 w-full`,
    fbStyle: `absolute bottom-0 left-0 sm:w-2/3 md:w-2/3 w-full`,
    fcStyle: `text-center p-20 md:p-44 md:w-1/2 sm:w-2/3 w-full text-black space-y-48 md:space-y-8`,
    tStyle: `text-center p-10 md:px-20 md:py-10 border border-gray-700`,
    xTopStyle: '',
    xBottomStyle: '',
    themeColor: 'bg-red-100',
    cd1: "bg-red-200 p-4 rounded-lg",
    cd2: "bg-red-300 p-4 rounded-lg",
    cd3: "bg-red-400 p-4 rounded-lg",
    cd4: "bg-red-500 p-4 rounded-lg",
    H2: Fonts.f2.H2,
    H2size: "text-6xl",
    fontP: Fonts.f2.fontP,
    ftPdf: `absolute top-0 right-0 w-full`,
    fbPdf: `absolute bottom-0 left-0 w-full`,
    fcPdf: `text-center p-8 w-3/4 text-black space-y-40`,
    H2Pdf: "text-4xl",
    whiteBg: "p-2 mx-4 bg-white opacity-80 z-10 rounded-lg",
  },
  theme35: {
    bg: `${process.env.REACT_APP_THEMES_URL}/bg35.jpg`,
    ft: `${process.env.REACT_APP_THEMES_URL}/ft35.png`,
    fb: `${process.env.REACT_APP_THEMES_URL}/fb35.png`,
    fc: '',
    ftStyle: `absolute top-0 right-0 md:w-1/2 sm:w-3/4 w-full`,
    fbStyle: `absolute bottom-0 left-0 md:w-1/2 sm:w-3/4 w-full`,
    fcStyle: `text-center p-20 md:w-1/2 sm:w-2/3 w-full text-black space-y-8`,
    tStyle: `text-center p-10 md:px-20 md:py-10 border border-gray-700`,
    xTopStyle: 100,
    xBottomStyle: -100,
    themeColor: 'bg-pink-100',
    cd1: "bg-pink-200 p-4 rounded-lg",
    cd2: "bg-pink-300 p-4 rounded-lg",
    cd3: "bg-pink-400 p-4 rounded-lg",
    cd4: "bg-pink-500 p-4 rounded-lg",
    H2: Fonts.f1.H2,
    H2size: "text-5xl",
    fontP: Fonts.f1.fontP,
    ftPdf: `absolute top-0 right-0 w-full`,
    fbPdf: `absolute bottom-0 left-0 w-full`,
    fcPdf: `text-center p-8 w-full text-black space-y-8`,
    H2Pdf: "text-4xl",
    whiteBg: "p-2 mx-4 bg-white opacity-80 z-10 rounded-lg",
  },
  theme36: {
    bg: `${process.env.REACT_APP_THEMES_URL}/bg36.jpg`,
    ft: `${process.env.REACT_APP_THEMES_URL}/ft36.png`,
    fb: `${process.env.REACT_APP_THEMES_URL}/fb36.png`,
    fc: '',
    ftStyle: `absolute top-0 left-0 md:w-1/3 sm:w-3/4 w-3/4`,
    fbStyle: `absolute bottom-0 right-0 md:w-1/3 sm:w-3/4 w-3/4`,
    fcStyle: `text-center p-20 md:w-1/2 sm:w-2/3 w-full text-black space-y-8`,
    tStyle: `text-center p-10 md:px-20 md:py-10 border border-gray-700`,
    xTopStyle: -100,
    xBottomStyle: 100,
    themeColor: 'bg-pink-100',
    cd1: "bg-pink-200 p-4 rounded-lg",
    cd2: "bg-pink-300 p-4 rounded-lg",
    cd3: "bg-pink-400 p-4 rounded-lg",
    cd4: "bg-pink-500 p-4 rounded-lg",
    H2: Fonts.f1.H2,
    H2size: "text-5xl",
    fontP: Fonts.f1.fontP,
    ftPdf: `absolute top-0 left-0 w-3/4`,
    fbPdf: `absolute bottom-0 right-0 w-3/4`,
    fcPdf: `text-center p-8 w-full text-black space-y-8`,
    H2Pdf: "text-4xl",
    whiteBg: "p-2 mx-4 bg-white opacity-80 z-10 rounded-lg",
  },
  theme37: {
    bg: `${process.env.REACT_APP_THEMES_URL}/bg37.jpg`,
    ft: `${process.env.REACT_APP_THEMES_URL}/ft37.png`,
    fb: `${process.env.REACT_APP_THEMES_URL}/fb37.png`,
    fc: '',
    ftStyle: `absolute top-0 right-0 md:w-1/2 sm:w-3/4 w-full`,
    fbStyle: `absolute bottom-0 left-0 md:w-1/2 sm:w-3/4 w-full`,
    fcStyle: `text-center p-20 md:w-1/2 sm:w-2/3 w-full text-neutral-50 space-y-8`,
    tStyle: `text-center p-10 md:px-20 md:py-10 border border-white`,
    xTopStyle: 100,
    xBottomStyle: -100,
    textColor: `text-neutral-50`,
    themeColor: 'bg-[#805f8d]',
    cd1: "bg-red-200 p-4 rounded-lg",
    cd2: "bg-red-300 p-4 rounded-lg",
    cd3: "bg-red-400 p-4 rounded-lg",
    cd4: "bg-red-500 p-4 rounded-lg",
    H2: Fonts.f7.H2,
    H2size: "text-5xl",
    fontP: Fonts.f7.fontP,
    ftPdf: `absolute top-0 right-0 w-full`,
    fbPdf: `absolute bottom-0 left-0 w-full`,
    fcPdf: `text-center p-8 w-full text-textcolor space-y-8`,
    H2Pdf: "text-4xl",
    whiteBg: "p-2 mx-4 bg-white opacity-80 z-10 rounded-lg",
  },
  theme38: {
    bg: `${process.env.REACT_APP_THEMES_URL}/bg38.jpg`,
    ft: `${process.env.REACT_APP_THEMES_URL}/ft38.png`,
    fb: `${process.env.REACT_APP_THEMES_URL}/fb38.png`,
    fc: `${process.env.REACT_APP_THEMES_URL}/fc38.png`,
    ftStyle: `absolute top-0 right-0 sm:w-2/3 md:w-1/5 w-1/2`,
    fbStyle: `absolute bottom-0 left-0 sm:w-2/3 md:w-1/5 w-1/2`,
    fcStyle: `text-center p-20 md:w-1/2 sm:w-2/3 w-full text-neutral-50 space-y-36 md:space-y-8`,
    tStyle: `text-center p-10 md:px-20 md:py-10 border border-gray-700`,
    xTopStyle: 100,
    xBottomStyle: -100,
    centerText: `text-black`,
    textColor: `text-neutral-50`,
    themeColor: 'bg-[#412649]',
    cd1: "bg-purple-400 p-4 rounded-lg",
    cd2: "bg-purple-500 p-4 rounded-lg",
    cd3: "bg-purple-600 p-4 rounded-lg",
    cd4: "bg-purple-700 p-4 rounded-lg",
    H2: Fonts.f2.H2,
    H2size: "text-6xl",
    fontP: Fonts.f2.fontP,
    ftPdf: `absolute top-0 right-0 w-2/5`,
    fbPdf: `absolute bottom-0 left-0 w-2/5`,
    fcPdf: `text-center p-8 w-2/3 text-textcolor space-y-24`,
    H2Pdf: "text-4xl",
    whiteBg: "p-2 mx-4 bg-white opacity-80 z-10 rounded-lg",
  },
  theme39: {
    bg: `${process.env.REACT_APP_THEMES_URL}/bg39.jpg`,
    ft: `${process.env.REACT_APP_THEMES_URL}/ft39.png`,
    fb: `${process.env.REACT_APP_THEMES_URL}/fb39.png`,
    fc: `${process.env.REACT_APP_THEMES_URL}/fc39.png`,
    ftStyle: `absolute bottom-0 left-0 sm:w-2/3 md:w-1/5 w-1/3`,
    fbStyle: `absolute bottom-0 right-0 sm:w-2/3 md:w-1/5 w-1/3`,
    fcStyle: `text-center p-20 md:p-44 md:w-1/2 sm:w-2/3 w-full text-black space-y-36 md:space-y-8`,
    tStyle: `text-center p-10 md:px-20 md:py-10 border border-gray-700`,
    xTopStyle: -100,
    xBottomStyle: 100,
    themeColor: 'bg-purple-100',
    cd1: "bg-purple-200 p-4 rounded-lg",
    cd2: "bg-purple-300 p-4 rounded-lg",
    cd3: "bg-purple-400 p-4 rounded-lg",
    cd4: "bg-purple-500 p-4 rounded-lg",
    H2: Fonts.f1.H2,
    H2size: "text-5xl",
    fontP: Fonts.f1.fontP,
    ftPdf: `absolute bottom-0 left-0 sm:w-2/3 md:w-1/5 w-1/3`,
    fbPdf: `absolute bottom-0 right-0 sm:w-2/3 md:w-1/5 w-1/3`,
    fcPdf: `text-center p-8 w-4/5 text-black space-y-28`,
    H2Pdf: "text-4xl",
    whiteBg: "p-2 mx-4 bg-white opacity-80 z-10 rounded-lg",
  },
  theme40: {
    bg: `${process.env.REACT_APP_THEMES_URL}/bg40.jpg`,
    ft: `${process.env.REACT_APP_THEMES_URL}/ft40.png`,
    fb: `${process.env.REACT_APP_THEMES_URL}/fb40.png`,
    fc: `${process.env.REACT_APP_THEMES_URL}/fc40.png`,
    ftStyle: `absolute top-50 left-0 sm:w-1/5 md:w-1/6 w-1/5`,
    fbStyle: `absolute top-50 right-0 sm:w-1/5 md:w-1/6 w-1/5`,
    fcStyle: `text-center p-28 md:p-44 md:w-1/2 sm:w-2/3 w-full text-black space-y-8 md:space-y-8`,
    tStyle: `text-center p-10 md:px-20 md:py-10 border border-gray-700`,
    xTopStyle: -100,
    xBottomStyle: 100,
    themeColor: 'bg-[#efe9e7]',
    cd1: "bg-pink-200 p-4 rounded-lg",
    cd2: "bg-pink-300 p-4 rounded-lg",
    cd3: "bg-pink-400 p-4 rounded-lg",
    cd4: "bg-pink-500 p-4 rounded-lg",
    H2: Fonts.f7.H2,
    H2size: "text-5xl",
    fontP: Fonts.f7.fontP,
    ftPdf: `absolute top-50 left-0 w-1/5`,
    fbPdf: `absolute top-50 right-0 w-1/5`,
    fcPdf: `text-center p-8 w-full h-full flex flex-col justify-center items-center text-black space-y-8`,
    H2Pdf: "text-4xl",
    whiteBg: "p-2 mx-4 bg-white opacity-80 z-10 rounded-lg",
  },
  theme41: {
    bg: `${process.env.REACT_APP_THEMES_URL}/bg41.jpg`,
    ft: `${process.env.REACT_APP_THEMES_URL}/ft41.png`,
    fb: `${process.env.REACT_APP_THEMES_URL}/fb41.png`,
    fc: `${process.env.REACT_APP_THEMES_URL}/fc41.png`,
    ftStyle: `absolute top-0 right-0 sm:w-1/2 md:w-1/4 w-2/3`,
    fbStyle: `absolute bottom-0 left-0 sm:w-1/2 md:w-1/4 w-2/3`,
    fcStyle: `text-center p-20 md:p-44 md:w-1/2 sm:w-2/3 w-full h-screen flex flex-col justify-center text-green-50 space-y-8`,
    tStyle: `text-center p-10 md:px-20 md:py-10 border border-gray-700`,
    xTopStyle: 100,
    xBottomStyle: -100,
    centerText: `text-green-50`,
    textColor: `text-green-600`,
    themeColor: 'bg-green-100',
    cd1: "bg-green-200 p-4 rounded-lg",
    cd2: "bg-green-300 p-4 rounded-lg",
    cd3: "bg-green-400 p-4 rounded-lg",
    cd4: "bg-green-500 p-4 rounded-lg",
    H2: Fonts.f18.H2,
    H2size: "text-6xl",
    fontP: Fonts.f7.fontP,
    ftPdf: `absolute top-0 right-0 w-2/3`,
    fbPdf: `absolute bottom-0 left-0 w-2/3`,
    fcPdf: `text-center p-8 w-3/4 h-screen flex flex-col justify-center text-green-50 space-y-8`,
    H2Pdf: "text-4xl",
    whiteBg: "p-2 mx-4 bg-white opacity-80 z-10 rounded-lg",
  },
  theme42: {
    bg: `${process.env.REACT_APP_THEMES_URL}/bg42.jpg`,
    ft: `${process.env.REACT_APP_THEMES_URL}/ft42.png`,
    fb: `${process.env.REACT_APP_THEMES_URL}/fb42.png`,
    fc: '',
    ftStyle: `absolute top-0 left-0 sm:w-auto md:w-1/5 sm:h-screen w-2/3`,
    fbStyle: `absolute bottom-0 right-0 sm:w-auto md:w-1/5 sm:h-screen w-2/3`,
    fcStyle: `text-center p-20 md:p-44 md:w-1/2 sm:w-2/3 w-full h-screen flex flex-col justify-center text-black space-y-8`,
    tStyle: `text-center p-10 md:px-20 md:py-10 border border-gray-700`,
    xTopStyle: -100,
    xBottomStyle: 100,
    centerText: `text-black`,
    textColor: `text-black`,
    themeColor: 'bg-pink-100',
    cd1: "bg-pink-200 p-4 rounded-lg",
    cd2: "bg-pink-300 p-4 rounded-lg",
    cd3: "bg-pink-400 p-4 rounded-lg",
    cd4: "bg-pink-500 p-4 rounded-lg",
    H2: Fonts.f2.H2,
    H2size: "text-6xl",
    fontP: Fonts.f2.fontP,
    ftPdf: `absolute top-0 left-0 w-2/3`,
    fbPdf: `absolute bottom-0 right-0 w-2/3`,
    fcPdf: `text-center p-8 w-full h-screen flex flex-col justify-center text-black space-y-8`,
    H2Pdf: "text-4xl",
    whiteBg: "p-2 mx-4 bg-white opacity-80 z-10 rounded-lg",
  },
  theme43: {
    bg: `${process.env.REACT_APP_THEMES_URL}/bg43.jpg`,
    ft: '',
    fb: '',
    fc: `${process.env.REACT_APP_THEMES_URL}/fc43.png`,
    ftStyle: `absolute top-0 right-0 sm:w-2/3 md:w-2/3 w-full`,
    fbStyle: `absolute bottom-0 left-0 sm:w-2/3 md:w-2/3 w-full`,
    fcStyle: `text-center p-20 md:p-44 md:w-1/2 sm:w-2/3 w-full text-black space-y-48 sm:space-y-8 h-screen flex flex-col justify-center`,
    tStyle: `text-center p-10 md:px-20 md:py-10 border border-gray-700`,
    xTopStyle: '',
    xBottomStyle: '',
    themeColor: 'bg-[#efedec]',
    cd1: "bg-neutral-100 p-4 rounded-lg",
    cd2: "bg-neutral-200 p-4 rounded-lg",
    cd3: "bg-neutral-300 p-4 rounded-lg",
    cd4: "bg-neutral-400 p-4 rounded-lg",
    H2: Fonts.f7.H2,
    H2size: "text-6xl",
    fontP: Fonts.f7.fontP,
    ftPdf: `absolute top-0 right-0 sm:w-2/3 md:w-2/3 w-full`,
    fbPdf: `absolute bottom-0 left-0 sm:w-2/3 md:w-2/3 w-full`,
    fcPdf: `text-center p-32 w-full text-black space-y-8 h-screen flex flex-col justify-center`,
    H2Pdf: "text-4xl",
    fontP: Fonts.f7.fontP,
    whiteBg: "p-2 mx-4 bg-white opacity-80 z-10 rounded-lg",
  },
  theme44: {
    bg: `${process.env.REACT_APP_THEMES_URL}/bg44.jpg`,
    ft: `${process.env.REACT_APP_THEMES_URL}/ft44.png`,
    fb: `${process.env.REACT_APP_THEMES_URL}/fb44.png`,
    fc: `${process.env.REACT_APP_THEMES_URL}/fc44.png`,
    ftStyle: `absolute top-0 left-0 sm:w-1/2 md:w-1/3 w-4/5`,
    fbStyle: `absolute bottom-0 right-0 sm:w-2/5 md:w-1/4 w-1/2`,
    fcStyle: `text-center p-20 md:p-44 md:w-1/2 sm:w-1/2 w-5/6 text-black space-y-8 h-full md:h-4/5 flex flex-col justify-center`,
    tStyle: `text-center p-10 md:px-20 md:py-10 border border-gray-700`,
    xTopStyle: -100,
    xBottomStyle: 100,
    centerText: `text-black`,
    textColor: `text-black`,
    themeColor: 'bg-neutral-100',
    cd1: "bg-neutral-200 p-4 rounded-lg",
    cd2: "bg-neutral-300 p-4 rounded-lg",
    cd3: "bg-neutral-400 p-4 rounded-lg",
    cd4: "bg-neutral-500 p-4 rounded-lg",
    H2: Fonts.f13.H2,
    H2size: "text-6xl",
    fontP: Fonts.f13.fontP,
    ftPdf: `absolute top-0 left-0 w-4/5`,
    fbPdf: `absolute bottom-0 right-0 w-1/2`,
    fcPdf: `text-center p-28 w-5/6 text-black space-y-8 h-full flex flex-col justify-center`,
    H2Pdf: "text-4xl",
    whiteBg: "p-2 mx-4 bg-white opacity-80 z-10 rounded-lg",
  },
  theme45: {
    bg: `${process.env.REACT_APP_THEMES_URL}/bg45.jpg`,
    ft: `${process.env.REACT_APP_THEMES_URL}/ft45.png`,
    fb: `${process.env.REACT_APP_THEMES_URL}/fb45.png`,
    fc: `${process.env.REACT_APP_THEMES_URL}/fc45.png`,
    ftStyle: `absolute top-50 left-0 w-auto h-1/2 sm:h-screen`,
    fbStyle: `absolute bottom-50 right-0 w-auto h-1/2 sm:h-screen`,
    fcStyle: `text-center p-20 md:p-44 md:w-1/2 sm:w-2/3 w-full text-black space-y-8 h-full sm:h-5/6 flex flex-col justify-center`,
    tStyle: `text-center p-10 md:px-20 md:py-10 border border-gray-700`,
    xTopStyle: -100,
    xBottomStyle: 100,
    centerText: `text-black`,
    textColor: `text-black`,
    themeColor: 'bg-neutral-100',
    cd1: "bg-neutral-200 p-4 rounded-lg",
    cd2: "bg-neutral-300 p-4 rounded-lg",
    cd3: "bg-neutral-400 p-4 rounded-lg",
    cd4: "bg-neutral-500 p-4 rounded-lg",
    H2: Fonts.f2.H2,
    H2size: "text-6xl",
    fontP: Fonts.f2.fontP,
    ftPdf: `absolute top-50 left-0 w-auto h-1/2`,
    fbPdf: `absolute bottom-50 right-0 w-auto h-1/2`,
    fcPdf: `text-center p-20 w-full text-black space-y-8 h-full flex flex-col justify-center`,
    H2Pdf: "text-4xl",
    whiteBg: "p-2 mx-4 bg-white opacity-80 z-10 rounded-lg",
  },
  theme46: {
    bg: `${process.env.REACT_APP_THEMES_URL}/bg46.jpg`,
    ft: `${process.env.REACT_APP_THEMES_URL}/ft46.png`,
    fb: `${process.env.REACT_APP_THEMES_URL}/fb46.png`,
    fc: '',
    ftStyle: `absolute top-50 left-0 w-auto h-1/2 sm:h-screen`,
    fbStyle: `absolute bottom-50 right-0 w-auto h-1/2 sm:h-screen`,
    fcStyle: `text-center p-20 md:p-44 md:w-1/2 sm:w-2/3 w-full text-black space-y-8 h-full md:h-4/5 flex flex-col justify-center`,
    tStyle: `text-center p-10 md:px-20 md:py-10 border border-gray-700`,
    xTopStyle: -100,
    xBottomStyle: 100,
    centerText: `text-black`,
    textColor: `text-black`,
    themeColor: 'bg-white',
    cd1: "bg-stone-100 p-4 rounded-lg",
    cd2: "bg-stone-200 p-4 rounded-lg",
    cd3: "bg-stone-300 p-4 rounded-lg",
    cd4: "bg-stone-400 p-4 rounded-lg",
    H2: Fonts.f1.H2,
    H2size: "text-6xl",
    fontP: Fonts.f1.fontP,
    ftPdf: `absolute top-50 left-0 w-auto h-1/2`,
    fbPdf: `absolute bottom-50 right-0 w-auto h-1/2`,
    fcPdf: `text-center p-20 w-full text-black space-y-8 h-full flex flex-col justify-center`,
    H2Pdf: "text-4xl",
    whiteBg: "p-2 mx-4 bg-white opacity-80 z-10 rounded-lg",
  },
  theme47: {
    bg: `${process.env.REACT_APP_THEMES_URL}/bg47.jpg`,
    ft: `${process.env.REACT_APP_THEMES_URL}/ft47.png`,
    fb: `${process.env.REACT_APP_THEMES_URL}/fb47.png`,
    fc: '',
    ftStyle: `absolute top-0 left-0 sm:w-2/3 md:w-1/2 w-4/5`,
    fbStyle: `absolute bottom-0 right-0 sm:w-2/3 md:w-1/3 w-2/3`,
    fcStyle: `text-center p-20 md:p-44 md:w-1/2 sm:w-2/3 w-5/6 text-black space-y-8 h-full md:h-4/5 flex flex-col justify-center`,
    tStyle: `text-center p-10 md:px-20 md:py-10 border border-gray-700`,
    xTopStyle: -100,
    xBottomStyle: 100,
    centerText: `text-black`,
    textColor: `text-black`,
    themeColor: 'bg-neutral-100',
    cd1: "bg-neutral-200 p-4 rounded-lg",
    cd2: "bg-neutral-300 p-4 rounded-lg",
    cd3: "bg-neutral-400 p-4 rounded-lg",
    cd4: "bg-neutral-500 p-4 rounded-lg",
    H2: Fonts.f13.H2,
    H2size: "text-6xl",
    fontP: Fonts.f13.fontP,
    ftPdf: `absolute top-0 left-0 w-4/5`,
    fbPdf: `absolute bottom-0 right-0 w-2/3`,
    fcPdf: `text-center p-28 w-5/6 text-black space-y-8 h-full flex flex-col justify-center`,
    H2Pdf: "text-4xl",
    whiteBg: "p-2 mx-4 bg-white opacity-80 z-10 rounded-lg",
  },
  theme48: {
    bg: `${process.env.REACT_APP_THEMES_URL}/bg48.jpg`,
    ft: `${process.env.REACT_APP_THEMES_URL}/ft48.png`,
    fb: `${process.env.REACT_APP_THEMES_URL}/fb48.png`,
    fc: '',
    ftStyle: `absolute top-0 left-0 sm:w-1/2 md:w-1/3 w-2/3`,
    fbStyle: `absolute bottom-0 right-0 sm:w-1/2 md:w-1/3 w-2/3`,
    fcStyle: `text-center p-20 md:p-44 md:w-1/2 sm:w-2/3 w-5/6 text-black space-y-8 h-full md:h-4/5 flex flex-col justify-center`,
    tStyle: `text-center p-10 md:px-20 md:py-10 border border-gray-700`,
    xTopStyle: -100,
    xBottomStyle: 100,
    centerText: `text-black`,
    textColor: `text-black`,
    themeColor: 'bg-neutral-100',
    cd1: "bg-neutral-200 p-4 rounded-lg",
    cd2: "bg-neutral-300 p-4 rounded-lg",
    cd3: "bg-neutral-400 p-4 rounded-lg",
    cd4: "bg-neutral-500 p-4 rounded-lg",
    H2: Fonts.f2.H2,
    H2size: "text-6xl",
    fontP: Fonts.f2.fontP,
    ftPdf: `absolute top-0 left-0 w-1/2`,
    fbPdf: `absolute bottom-0 right-0 w-1/2`,
    fcPdf: `text-center p-20 w-5/6 text-black space-y-8 h-full flex flex-col justify-center`,
    H2Pdf: "text-4xl",
    whiteBg: "p-2 mx-4 bg-white opacity-80 z-10 rounded-lg",
  },
  theme49: {
    bg: `${process.env.REACT_APP_THEMES_URL}/bg49.jpg`,
    ft: '',
    fb: '',
    fc: `${process.env.REACT_APP_THEMES_URL}/fc49.png`,
    ftStyle: `absolute top-0 right-0 sm:w-2/3 md:w-2/3 w-full`,
    fbStyle: `absolute bottom-0 left-0 sm:w-2/3 md:w-2/3 w-full`,
    fcStyle: `text-center p-20 md:p-44 md:w-1/2 sm:w-2/3 w-full text-black space-y-48 md:space-y-8 h-screen flex flex-col justify-center`,
    tStyle: `text-center p-10 md:px-20 md:py-10 border border-gray-700`,
    xTopStyle: '',
    xBottomStyle: '',
    themeColor: 'bg-neutral-100',
    cd1: "bg-neutral-100 p-4 rounded-lg",
    cd2: "bg-neutral-200 p-4 rounded-lg",
    cd3: "bg-neutral-300 p-4 rounded-lg",
    cd4: "bg-neutral-400 p-4 rounded-lg",
    H2: Fonts.f18.H2,
    H2size: "text-6xl",
    fontP: Fonts.f18.fontP,
    ftPdf: `absolute top-0 right-0 w-full`,
    fbPdf: `absolute bottom-0 left-0 w-full`,
    fcPdf: `text-center p-20 w-full text-black space-y-8 h-screen flex flex-col justify-center`,
    H2Pdf: "text-4xl",
    whiteBg: "p-2 mx-4 bg-white opacity-80 z-10 rounded-lg",
  },
  theme50: {
    bg: '',
    ft: `${process.env.REACT_APP_THEMES_URL}/ft50.png`,
    fb: `${process.env.REACT_APP_THEMES_URL}/fb50.png`,
    fc: `${process.env.REACT_APP_THEMES_URL}/fc50.png`,
    ftStyle: `absolute top-50 left-0 sm:w-auto md:w-1/5 sm:h-screen w-1/2`,
    fbStyle: `absolute bottom-50 right-0 sm:w-auto md:w-1/5 sm:h-screen w-1/2`,
    fcStyle: `z-10 text-center p-20 md:p-44 md:w-1/2 sm:w-2/3 w-full sm:h-screen flex flex-col justify-center text-black space-y-8`,
    tStyle: `text-center p-10 md:px-20 md:py-10 border border-gray-700`,
    xTopStyle: -100,
    xBottomStyle: 100,
    centerText: `text-black`,
    textColor: `text-black`,
    themeColor: 'bg-pink-100',
    cd1: "bg-pink-200 p-4 rounded-lg",
    cd2: "bg-pink-300 p-4 rounded-lg",
    cd3: "bg-pink-400 p-4 rounded-lg",
    cd4: "bg-pink-500 p-4 rounded-lg",
    H2: Fonts.f7.H2,
    H2size: "text-6xl",
    fontP: Fonts.f7.fontP,
    ftPdf: `absolute top-50 left-0 w-1/2`,
    fbPdf: `absolute bottom-50 right-0 w-1/2`,
    fcPdf: `z-10 text-center p-20 w-full flex flex-col justify-center text-black space-y-8`,
    H2Pdf: "text-4xl",
    whiteBg: "p-2 mx-4 bg-white opacity-80 z-10 rounded-lg",
  },
  theme51: {
    bg: `${process.env.REACT_APP_THEMES_URL}/bg51.jpg`,
    ft: `${process.env.REACT_APP_THEMES_URL}/ft51.png`,
    fb: `${process.env.REACT_APP_THEMES_URL}/fb51.png`,
    fc: `${process.env.REACT_APP_THEMES_URL}/fc51.png`,
    ftStyle: `absolute top-0 left-0 w-auto h-1/2 sm:h-screen`,
    fbStyle: `absolute bottom-0 right-0 w-auto h-2/5 sm:h-screen`,
    fcStyle: `text-center p-20 md:p-44 md:w-1/2 sm:w-2/3 w-4/5 text-black space-y-8 h-full sm:h-4/5 flex flex-col justify-center`,
    tStyle: `text-center p-10 md:px-20 md:py-10 border border-gray-700`,
    xTopStyle: -100,
    xBottomStyle: 100,
    centerText: `text-black`,
    textColor: `text-black`,
    themeColor: 'bg-neutral-100',
    cd1: "bg-neutral-200 p-4 rounded-lg",
    cd2: "bg-neutral-300 p-4 rounded-lg",
    cd3: "bg-neutral-400 p-4 rounded-lg",
    cd4: "bg-neutral-500 p-4 rounded-lg",
    H2: Fonts.f2.H2,
    H2size: "text-6xl",
    fontP: Fonts.f2.fontP,
    ftPdf: `absolute top-0 left-0 w-auto h-3/4`,
    fbPdf: `absolute bottom-0 right-0 w-auto h-3/5`,
    fcPdf: `text-center p-20 w-4/5 text-black space-y-8 h-full flex flex-col justify-center`,
    H2Pdf: "text-4xl",
    whiteBg: "p-2 mx-4 bg-white opacity-80 z-10 rounded-lg",
  },
  theme52: {
    bg: `${process.env.REACT_APP_THEMES_URL}/bg52.jpg`,
    ft: `${process.env.REACT_APP_THEMES_URL}/ft52.png`,
    fb: `${process.env.REACT_APP_THEMES_URL}/fb52.png`,
    fc: '',
    ftStyle: `absolute top-0 right-0 sm:w-1/3 md:w-1/5 w-1/2`,
    fbStyle: `absolute bottom-0 left-0 sm:w-1/3 md:w-1/5 w-1/2`,
    fcStyle: `text-center p-20 md:p-44 md:w-1/2 sm:w-2/3 w-5/6 text-black space-y-8 h-full md:h-4/5 flex flex-col justify-center`,
    tStyle: `text-center p-10 md:px-20 md:py-10 border border-gray-700`,
    xTopStyle: 100,
    xBottomStyle: -100,
    centerText: `text-black`,
    textColor: `text-black`,
    themeColor: 'bg-gray-50',
    cd1: "bg-neutral-200 p-4 rounded-lg",
    cd2: "bg-neutral-300 p-4 rounded-lg",
    cd3: "bg-neutral-400 p-4 rounded-lg",
    cd4: "bg-neutral-500 p-4 rounded-lg",
    H2: Fonts.f2.H2,
    H2size: "text-6xl",
    fontP: Fonts.f2.fontP,
    ftPdf: `absolute top-0 right-0 w-2/5`,
    fbPdf: `absolute bottom-0 left-0 w-2/5`,
    fcPdf: `text-center p-20 w-5/6 text-black space-y-8 h-full flex flex-col justify-center`,
    H2Pdf: "text-4xl",
    whiteBg: "p-2 mx-4 bg-white opacity-80 z-10 rounded-lg",
  },
  theme53: {
    bg: `${process.env.REACT_APP_THEMES_URL}/bg53.jpg`,
    ft: `${process.env.REACT_APP_THEMES_URL}/ft53.png`,
    fb: `${process.env.REACT_APP_THEMES_URL}/fb53.png`,
    fc: '',
    ftStyle: `absolute top-0 left-0 sm:w-1/3 md:w-1/5 w-2/3`,
    fbStyle: `absolute bottom-0 right-0 sm:w-1/3 md:w-1/5 w-2/3`,
    fcStyle: `text-center p-20 md:p-44 md:w-1/2 sm:w-2/3 w-5/6 text-black space-y-8 h-full md:h-4/5 flex flex-col justify-center`,
    tStyle: `text-center p-10 md:px-20 md:py-10 border border-gray-700`,
    xTopStyle: -100,
    xBottomStyle: 100,
    centerText: `text-black`,
    textColor: `text-black`,
    themeColor: 'bg-neutral-50',
    cd1: "bg-neutral-200 p-4 rounded-lg",
    cd2: "bg-neutral-300 p-4 rounded-lg",
    cd3: "bg-neutral-400 p-4 rounded-lg",
    cd4: "bg-neutral-500 p-4 rounded-lg",
    H2: Fonts.f1.H2,
    H2size: "text-6xl",
    fontP: Fonts.f1.fontP,
    ftPdf: `absolute top-0 left-0 w-2/3`,
    fbPdf: `absolute bottom-0 right-0 w-2/3`,
    fcPdf: `text-center p-20 w-5/6 text-black space-y-8 h-full flex flex-col justify-center`,
    H2Pdf: "text-4xl",
    whiteBg: "p-2 mx-4 bg-white opacity-80 z-10 rounded-lg",
  },
  theme54: {
    bg: `${process.env.REACT_APP_THEMES_URL}/bg54.jpg`,
    ft: `${process.env.REACT_APP_THEMES_URL}/ft54.png`,
    fb: `${process.env.REACT_APP_THEMES_URL}/fb54.png`,
    fc: `${process.env.REACT_APP_THEMES_URL}/fc54.png`,
    ftStyle: `absolute top-0 right-0 w-3/4 sm:w-1/2 md:w-1/3`,
    fbStyle: `absolute bottom-0 left-0 w-3/4 sm:w-1/2 md:w-1/3`,
    fcStyle: `text-center p-20 md:p-44 md:w-1/2 sm:w-2/3 w-full text-black space-y-28 sm:space-y-8 h-full sm:h-4/5 flex flex-col justify-center`,
    tStyle: `text-center p-10 md:px-20 md:py-10 border border-gray-700`,
    xTopStyle: 100,
    xBottomStyle: -100,
    centerText: `text-black`,
    textColor: `text-black`,
    themeColor: 'bg-neutral-50',
    cd1: "bg-blue-200 p-4 rounded-lg",
    cd2: "bg-blue-300 p-4 rounded-lg",
    cd3: "bg-blue-400 p-4 rounded-lg",
    cd4: "bg-blue-500 p-4 rounded-lg",
    H2: Fonts.f7.H2,
    H2size: "text-6xl",
    fontP: Fonts.f7.fontP,
    ftPdf: `absolute top-0 right-0 w-3/4`,
    fbPdf: `absolute bottom-0 left-0 w-3/4`,
    fcPdf: `text-center p-20 w-full text-black space-y-8 h-full flex flex-col justify-center`,
    H2Pdf: "text-4xl",
    whiteBg: "p-2 mx-4 bg-white opacity-80 z-10 rounded-lg",
  },
  theme55: {
    bg: `${process.env.REACT_APP_THEMES_URL}/bg55.jpg`,
    ft: `${process.env.REACT_APP_THEMES_URL}/ft55.png`,
    fb: `${process.env.REACT_APP_THEMES_URL}/fb55.png`,
    fc: '',
    ftStyle: `absolute top-0 left-0 sm:w-2/3 md:w-1/2 w-full`,
    fbStyle: `absolute bottom-0 right-0 sm:w-2/3 md:w-1/2 w-full`,
    fcStyle: `text-center p-20 md:p-44 md:w-1/2 sm:w-2/3 w-5/6 text-black space-y-8 h-full md:h-4/5 flex flex-col justify-center`,
    tStyle: `text-center p-10 md:px-20 md:py-10 border border-gray-700`,
    xTopStyle: -100,
    xBottomStyle: 100,
    centerText: `text-black`,
    textColor: `text-black`,
    themeColor: 'bg-neutral-50',
    cd1: "bg-neutral-200 p-4 rounded-lg",
    cd2: "bg-neutral-300 p-4 rounded-lg",
    cd3: "bg-neutral-400 p-4 rounded-lg",
    cd4: "bg-neutral-500 p-4 rounded-lg",
    H2: Fonts.f2.H2,
    H2size: "text-6xl",
    fontP: Fonts.f2.fontP,
    ftPdf: `absolute top-0 left-0 w-4/5`,
    fbPdf: `absolute bottom-0 right-0 w-4/5`,
    fcPdf: `text-center p-20 w-5/6 text-black space-y-8 h-full flex flex-col justify-center`,
    H2Pdf: "text-4xl",
    whiteBg: "p-2 mx-4 bg-white opacity-80 z-10 rounded-lg",
  },
  theme56: {
    bg: '',
    ft: `${process.env.REACT_APP_THEMES_URL}/ft56.png`,
    fb: `${process.env.REACT_APP_THEMES_URL}/fb56.png`,
    fc: '',
    ftStyle: `absolute top-0 left-0 w-4/5 sm:w-auto sm:h-screen`,
    fbStyle: `absolute bottom-0 right-0 w-4/5 sm:w-auto sm:h-screen`,
    fcStyle: `text-center p-20 md:p-44 md:w-1/2 sm:w-2/3 w-5/6 text-black space-y-8 h-full md:h-4/5 flex flex-col justify-center`,
    tStyle: `text-center p-10 md:px-20 md:py-10 border border-blue-600`,
    xTopStyle: -100,
    xBottomStyle: 100,
    centerText: `text-black`,
    textColor: `text-black`,
    themeColor: 'bg-neutral-50',
    cd1: "bg-blue-200 p-4 rounded-lg",
    cd2: "bg-blue-300 p-4 rounded-lg",
    cd3: "bg-blue-400 p-4 rounded-lg",
    cd4: "bg-blue-500 p-4 rounded-lg",
    H2: Fonts.f13.H2,
    H2size: "text-6xl",
    fontP: Fonts.f13.fontP,
    ftPdf: `absolute top-0 left-0 w-4/5`,
    fbPdf: `absolute bottom-0 right-0 w-4/5`,
    fcPdf: `text-center p-20 w-5/6 text-black space-y-8 h-full flex flex-col justify-center`,
    H2Pdf: "text-4xl",
    whiteBg: "p-2 mx-4 bg-white opacity-80 z-10 rounded-lg",
  },
  theme57: {
    bg: `${process.env.REACT_APP_THEMES_URL}/bg57.jpg`,
    ft: '',
    fb: '',
    fc: `${process.env.REACT_APP_THEMES_URL}/fc57.png`,
    ftStyle: `absolute top-0 right-0 sm:w-2/3 md:w-2/3 w-full`,
    fbStyle: `absolute bottom-0 left-0 sm:w-2/3 md:w-2/3 w-full`,
    fcStyle: `text-center p-20 md:p-44 md:w-1/2 sm:w-full w-full text-black space-y-48 sm:space-y-8 h-screen flex flex-col justify-center`,
    tStyle: `text-center p-10 md:px-20 md:py-10 border border-pink-500`,
    xTopStyle: '',
    xBottomStyle: '',
    themeColor: 'bg-neutral-50',
    cd1: "bg-pink-100 p-4 rounded-lg",
    cd2: "bg-pink-200 p-4 rounded-lg",
    cd3: "bg-pink-300 p-4 rounded-lg",
    cd4: "bg-pink-400 p-4 rounded-lg",
    H2: Fonts.f2.H2,
    H2size: "text-5xl",
    fontP: Fonts.f2.fontP,
    ftPdf: `absolute top-0 right-0 w-full`,
    fbPdf: `absolute bottom-0 left-0 w-full`,
    fcPdf: `text-center p-20 w-full text-black space-y-36 h-screen flex flex-col justify-center`,
    H2Pdf: "text-4xl",
    whiteBg: "p-2 mx-4 bg-white opacity-80 z-10 rounded-lg",
  },
  theme58: {
    bg: `${process.env.REACT_APP_THEMES_URL}/bg58.jpg`,
    ft: `${process.env.REACT_APP_THEMES_URL}/ft58.png`,
    fb: `${process.env.REACT_APP_THEMES_URL}/fb58.png`,
    fc: '',
    ftStyle: `absolute top-0 left-0 sm:h-screen w-3/4 sm:w-auto`,
    fbStyle: `absolute bottom-0 right-0 sm:h-screen w-1/2 sm:w-auto`,
    fcStyle: `text-center p-20 md:p-44 md:w-1/2 sm:w-2/3 w-5/6 text-black space-y-8 h-full md:h-4/5 flex flex-col justify-center`,
    tStyle: `text-center p-10 md:px-20 md:py-10 border border-blue-600`,
    xTopStyle: -100,
    xBottomStyle: 100,
    centerText: `text-black`,
    textColor: `text-black`,
    themeColor: 'bg-neutral-50',
    cd1: "bg-blue-200 p-4 rounded-lg",
    cd2: "bg-blue-300 p-4 rounded-lg",
    cd3: "bg-blue-400 p-4 rounded-lg",
    cd4: "bg-blue-500 p-4 rounded-lg",
    H2: Fonts.f1.H2,
    H2size: "text-6xl",
    fontP: Fonts.f1.fontP,
    ftPdf: `absolute top-0 left-0 w-3/4`,
    fbPdf: `absolute bottom-0 right-0 w-3/4`,
    fcPdf: `text-center p-20 w-5/6 text-black space-y-8 h-full flex flex-col justify-center`,
    H2Pdf: "text-4xl",
    whiteBg: "p-2 mx-4 bg-white opacity-80 z-10 rounded-lg",
  },
  theme59: {
    bg: `${process.env.REACT_APP_THEMES_URL}/bg59.jpg`,
    ft: `${process.env.REACT_APP_THEMES_URL}/ft59.png`,
    fb: `${process.env.REACT_APP_THEMES_URL}/fb59.png`,
    fc: `${process.env.REACT_APP_THEMES_URL}/fc59.png`,
    ftStyle: `absolute top-0 left-0 w-3/4 sm:w-1/2 md:w-1/2`,
    fbStyle: `absolute bottom-0 right-0 w-3/4 sm:w-1/2 md:w-1/2`,
    fcStyle: `text-center p-20 md:p-44 md:w-1/2 sm:w-2/3 w-4/5 text-black space-y-28 sm:space-y-8 h-full sm:h-4/5 flex flex-col justify-center`,
    tStyle: `text-center p-10 md:px-20 md:py-10 border border-stone-700`,
    xTopStyle: -100,
    xBottomStyle: 100,
    centerText: `text-black`,
    textColor: `text-black`,
    themeColor: 'bg-stone-100',
    cd1: "bg-stone-200 p-4 rounded-lg",
    cd2: "bg-stone-300 p-4 rounded-lg",
    cd3: "bg-stone-400 p-4 rounded-lg",
    cd4: "bg-stone-500 p-4 rounded-lg",
    H2: Fonts.f2.H2,
    H2size: "text-6xl",
    fontP: Fonts.f2.fontP,
    ftPdf: `absolute top-0 left-0 w-3/4`,
    fbPdf: `absolute bottom-0 right-0 w-3/4`,
    fcPdf: `text-center p-20 w-4/5 text-black space-y-8 h-full flex flex-col justify-center`,
    H2Pdf: "text-4xl",
    fontP: Fonts.f2.fontP,
    whiteBg: "p-2 mx-4 bg-white opacity-80 z-10 rounded-lg",
  },
  theme60: {
    bg: `${process.env.REACT_APP_THEMES_URL}/bg60.jpg`,
    ft: `${process.env.REACT_APP_THEMES_URL}/ft60.png`,
    fb: `${process.env.REACT_APP_THEMES_URL}/fb60.png`,
    fc: `${process.env.REACT_APP_THEMES_URL}/fc60.png`,
    ftStyle: `absolute top-0 right-0 w-3/5 sm:w-1/2 md:w-1/3`,
    fbStyle: `absolute bottom-0 left-0 w-3/5 sm:w-1/2 md:w-1/3`,
    fcStyle: `text-center p-20 md:p-44 md:w-1/2 sm:w-2/3 w-full text-black space-y-28 sm:space-y-8 h-full sm:h-4/5 flex flex-col justify-center`,
    tStyle: `text-center p-10 md:px-20 md:py-10 border border-stone-700`,
    xTopStyle: 100,
    xBottomStyle: -100,
    centerText: `text-black`,
    textColor: `text-black`,
    themeColor: 'bg-neutral-50',
    cd1: "bg-neutral-200 p-4 rounded-lg",
    cd2: "bg-neutral-300 p-4 rounded-lg",
    cd3: "bg-neutral-400 p-4 rounded-lg",
    cd4: "bg-neutral-500 p-4 rounded-lg",
    H2: Fonts.f2.H2,
    H2size: "text-6xl",
    fontP: Fonts.f2.fontP,
    ftPdf: `absolute top-0 right-0 w-3/5`,
    fbPdf: `absolute bottom-0 left-0 w-3/5`,
    fcPdf: `text-center p-20 w-full text-black space-y-8 h-full flex flex-col justify-center`,
    H2Pdf: "text-4xl",
    whiteBg: "p-2 mx-4 bg-white opacity-80 z-10 rounded-lg",
  },
  theme61: {
    bg: `${process.env.REACT_APP_THEMES_URL}/bg61.jpg`,
    ft: `${process.env.REACT_APP_THEMES_URL}/ft61.png`,
    fb: `${process.env.REACT_APP_THEMES_URL}/fb61.png`,
    fc: `${process.env.REACT_APP_THEMES_URL}/fc61.png`,
    ftStyle: `absolute top-0 left-0 w-3/5 sm:w-1/2 md:w-auto md:h-screen`,
    fbStyle: `absolute bottom-0 right-0 w-3/5 sm:w-1/2 md:w-auto md:h-screen`,
    fcStyle: `text-center p-20 md:p-44 md:w-1/2 sm:w-2/3 w-5/6 text-black space-y-28 sm:space-y-8 h-full sm:h-4/5 flex flex-col justify-center`,
    tStyle: `text-center p-10 md:px-20 md:py-10 border border-neutral-200`,
    xTopStyle: -100,
    xBottomStyle: 100,
    centerText: `text-black`,
    textColor: `text-black`,
    themeColor: 'bg-neutral-50',
    cd1: "bg-neutral-200 p-4 rounded-lg",
    cd2: "bg-neutral-300 p-4 rounded-lg",
    cd3: "bg-neutral-400 p-4 rounded-lg",
    cd4: "bg-neutral-500 p-4 rounded-lg",
    H2: Fonts.f2.H2,
    H2size: "text-6xl",
    fontP: Fonts.f2.fontP,
    ftPdf: `absolute top-0 left-0 w-3/5`,
    fbPdf: `absolute bottom-0 right-0 w-3/5`,
    fcPdf: `text-center p-20 w-4/5 text-black space-y-8 h-full flex flex-col justify-center`,
    H2Pdf: "text-4xl",
    whiteBg: "p-2 mx-4 bg-white opacity-80 z-10 rounded-lg",
  },
  theme62: {
    bg: `${process.env.REACT_APP_THEMES_URL}/bg62.jpg`,
    ft: `${process.env.REACT_APP_THEMES_URL}/ft62.png`,
    fb: `${process.env.REACT_APP_THEMES_URL}/fb62.png`,
    fc: '',
    ftStyle: `absolute top-0 left-0 h-1/2 sm:h-2/3 sm:w-auto`,
    fbStyle: `absolute bottom-0 right-0 h-1/2 sm:h-2/3 sm:w-auto`,
    fcStyle: `text-center p-20 md:p-44 md:w-1/2 sm:w-2/3 w-5/6 text-black space-y-8 h-full md:h-4/5 flex flex-col justify-center`,
    tStyle: `text-center p-10 md:px-20 md:py-10 border border-gray-600`,
    xTopStyle: -100,
    xBottomStyle: 100,
    centerText: `text-black`,
    textColor: `text-black`,
    themeColor: 'bg-gray-100',
    cd1: "bg-gray-200 p-4 rounded-lg",
    cd2: "bg-gray-300 p-4 rounded-lg",
    cd3: "bg-gray-400 p-4 rounded-lg",
    cd4: "bg-gray-500 p-4 rounded-lg",
    H2: Fonts.f2.H2,
    H2size: "text-6xl",
    fontP: Fonts.f2.fontP,
    ftPdf: `absolute top-0 left-0 h-1/2`,
    fbPdf: `absolute bottom-0 right-0 h-1/2`,
    fcPdf: `text-center p-20 w-5/6 text-black space-y-8 h-full flex flex-col justify-center`,
    H2Pdf: "text-4xl",
    whiteBg: "p-2 mx-4 bg-white opacity-80 z-10 rounded-lg",
  },
  theme63: {
    bg: `${process.env.REACT_APP_THEMES_URL}/bg63.jpg`,
    ft: `${process.env.REACT_APP_THEMES_URL}/ft63.png`,
    fb: `${process.env.REACT_APP_THEMES_URL}/fb63.png`,
    fc: '',
    ftStyle: `absolute top-0 left-0 h-1/3 sm:h-1/2 sm:w-auto`,
    fbStyle: `absolute bottom-0 right-0 h-1/3 sm:h-1/2 sm:w-auto`,
    fcStyle: `text-center p-20 md:p-44 md:w-1/2 sm:w-2/3 w-5/6 text-black space-y-8 h-full md:h-4/5 flex flex-col justify-center`,
    tStyle: `text-center p-10 md:px-20 md:py-10 border border-gray-600`,
    xTopStyle: -100,
    xBottomStyle: 100,
    centerText: `text-black`,
    textColor: `text-black`,
    themeColor: 'bg-neutral-50',
    cd1: "bg-neutral-200 p-4 rounded-lg",
    cd2: "bg-neutral-300 p-4 rounded-lg",
    cd3: "bg-neutral-400 p-4 rounded-lg",
    cd4: "bg-neutral-500 p-4 rounded-lg",
    H2: Fonts.f2.H2,
    H2size: "text-6xl",
    fontP: Fonts.f2.fontP,
    ftPdf: `absolute top-0 left-0 h-2/5`,
    fbPdf: `absolute bottom-0 right-0 h-2/5`,
    fcPdf: `text-center p-20 w-5/6 text-black space-y-8 h-full flex flex-col justify-center`,
    H2Pdf: "text-4xl",
    whiteBg: "p-2 mx-4 bg-white opacity-80 z-10 rounded-lg",
  },
  theme64: {
    bg: '',
    ft: `${process.env.REACT_APP_THEMES_URL}/ft64.png`,
    fb: `${process.env.REACT_APP_THEMES_URL}/fb64.png`,
    fc: `${process.env.REACT_APP_THEMES_URL}/fc64.png`,
    ftStyle: `absolute top-0 right-0 w-2/3 sm:w-1/3`,
    fbStyle: `absolute bottom-0 left-0 w-2/3 sm:w-1/3`,
    fcStyle: `text-center p-20 md:p-44 md:w-1/2 sm:w-2/3 w-full sm:h-screen flex flex-col justify-center text-black space-y-8`,
    tStyle: `text-center p-10 md:px-20 md:py-10 border border-gray-700`,
    xTopStyle: 100,
    xBottomStyle: -100,
    centerText: `text-black`,
    textColor: `text-black`,
    themeColor: 'bg-white',
    cd1: "bg-neutral-200 p-4 rounded-lg",
    cd2: "bg-neutral-300 p-4 rounded-lg",
    cd3: "bg-neutral-400 p-4 rounded-lg",
    cd4: "bg-neutral-500 p-4 rounded-lg",
    H2: Fonts.f2.H2,
    H2size: "text-6xl",
    fontP: Fonts.f2.fontP,
    ftPdf: `absolute top-0 right-0 w-1/2`,
    fbPdf: `absolute bottom-0 left-0 w-1/2`,
    fcPdf: `text-center p-20 w-full flex flex-col justify-center text-black space-y-8`,
    H2Pdf: "text-4xl",
    whiteBg: "p-2 mx-4 bg-white opacity-80 z-10 rounded-lg",
  },
  theme65: {
    bg: `${process.env.REACT_APP_THEMES_URL}/bg65.jpg`,
    ft: '',
    fb: '',
    fc: `${process.env.REACT_APP_THEMES_URL}/fc65.png`,
    ftStyle: `absolute top-0 right-0 sm:w-2/3 md:w-2/3 w-full`,
    fbStyle: `absolute bottom-0 left-0 sm:w-2/3 md:w-2/3 w-full`,
    fcStyle: `text-center p-20 md:p-44 md:w-1/2 sm:w-full w-full text-black space-y-48 sm:space-y-8 h-screen flex flex-col justify-center`,
    tStyle: `text-center p-10 md:px-20 md:py-10 border border-pink-500`,
    xTopStyle: '',
    xBottomStyle: '',
    themeColor: 'bg-pink-50',
    cd1: "bg-pink-100 p-4 rounded-lg",
    cd2: "bg-pink-200 p-4 rounded-lg",
    cd3: "bg-pink-300 p-4 rounded-lg",
    cd4: "bg-pink-400 p-4 rounded-lg",
    H2: Fonts.f1.H2,
    H2size: "text-5xl",
    fontP: Fonts.f1.fontP,
    ftPdf: `absolute top-0 right-0 w-full`,
    fbPdf: `absolute bottom-0 left-0 w-full`,
    fcPdf: `text-center p-20 w-4/5 text-black space-y-28 flex flex-col justify-center`,
    H2Pdf: "text-4xl",
    whiteBg: "p-2 mx-4 bg-white opacity-80 z-10 rounded-lg",
  },
  theme66: {
    bg: `${process.env.REACT_APP_THEMES_URL}/bg66.jpg`,
    ft: `${process.env.REACT_APP_THEMES_URL}/ft66.png`,
    fb: `${process.env.REACT_APP_THEMES_URL}/fb66.png`,
    fc: `${process.env.REACT_APP_THEMES_URL}/fc66.png`,
    ftStyle: `absolute top-0 right-0 w-3/5 sm:w-1/2 md:w-auto md:h-screen`,
    fbStyle: `absolute bottom-0 left-0 w-3/5 sm:w-1/2 md:w-auto md:h-screen`,
    fcStyle: `z-10 text-center p-20 md:p-44 md:w-1/2 sm:w-2/3 w-5/6 text-black space-y-28 sm:space-y-8 h-full sm:h-4/5 flex flex-col justify-center`,
    tStyle: `text-center p-10 md:px-20 md:py-10 border border-rose-500`,
    xTopStyle: 100,
    xBottomStyle: -100,
    centerText: `text-black`,
    textColor: `text-black`,
    themeColor: 'bg-rose-50',
    cd1: "bg-rose-200 p-4 rounded-lg",
    cd2: "bg-rose-300 p-4 rounded-lg",
    cd3: "bg-rose-400 p-4 rounded-lg",
    cd4: "bg-rose-500 p-4 rounded-lg",
    H2: Fonts.f13.H2,
    H2size: "text-6xl",
    fontP: Fonts.f13.fontP,
    ftPdf: `absolute top-0 right-0 w-3/5`,
    fbPdf: `absolute bottom-0 left-0 w-3/5`,
    fcPdf: `z-10 text-center p-20 w-5/6 text-black space-y-8 h-full flex flex-col justify-center`,
    H2Pdf: "text-4xl",
    whiteBg: "p-2 mx-4 bg-white opacity-80 z-10 rounded-lg",
  },
  theme67: {
    bg: `${process.env.REACT_APP_THEMES_URL}/bg67.jpg`,
    ft: `${process.env.REACT_APP_THEMES_URL}/ft67.png`,
    fb: `${process.env.REACT_APP_THEMES_URL}/fb67.png`,
    fc: `${process.env.REACT_APP_THEMES_URL}/fc67.png`,
    ftStyle: `absolute top-0 left-0 w-full sm:w-3/4 md:w-3/5`,
    fbStyle: `absolute bottom-0 right-0 w-full sm:w-3/4 md:w-3/5`,
    fcStyle: `z-10 text-center p-20 md:p-44 md:w-1/2 sm:w-2/3 w-5/6 text-black space-y-28 sm:space-y-8 h-full sm:h-4/5 flex flex-col justify-center`,
    tStyle: `text-center p-10 md:px-20 md:py-10 border border-orange-500`,
    xTopStyle: -100,
    xBottomStyle: 100,
    centerText: `text-black`,
    textColor: `text-black`,
    themeColor: 'bg-stone-100',
    cd1: "bg-orange-200 p-4 rounded-lg",
    cd2: "bg-orange-300 p-4 rounded-lg",
    cd3: "bg-orange-400 p-4 rounded-lg",
    cd4: "bg-orange-500 p-4 rounded-lg",
    H2: Fonts.f7.H2,
    H2size: "text-6xl",
    fontP: Fonts.f7.fontP,
    ftPdf: `absolute top-0 left-0 w-full`,
    fbPdf: `absolute bottom-0 right-0 w-full`,
    fcPdf: `z-10 text-center p-20 w-5/6 text-black space-y-8 h-full flex flex-col justify-center`,
    H2Pdf: "text-4xl",
    whiteBg: "p-2 mx-4 bg-white opacity-80 z-10 rounded-lg",
  },
  theme68: {
    bg: `${process.env.REACT_APP_THEMES_URL}/bg68.jpg`,
    ft: `${process.env.REACT_APP_THEMES_URL}/ft68.png`,
    fb: `${process.env.REACT_APP_THEMES_URL}/fb68.png`,
    fc: `${process.env.REACT_APP_THEMES_URL}/fc68.png`,
    ftStyle: `absolute top-0 right-0 w-3/4 sm:w-1/2 md:w-1/3`,
    fbStyle: `absolute bottom-0 left-0 w-3/4 sm:w-1/2 md:w-1/3`,
    fcStyle: `z-10 text-center p-20 md:p-44 md:w-1/2 sm:w-2/3 w-full text-black space-y-28 sm:space-y-8 h-full sm:h-4/5 flex flex-col justify-center`,
    tStyle: `text-center p-10 md:px-20 md:py-10 border border-neutral-500`,
    xTopStyle: 100,
    xBottomStyle: -100,
    centerText: `text-black`,
    textColor: `text-black`,
    themeColor: 'bg-neutral-100',
    cd1: "bg-neutral-200 p-4 rounded-lg",
    cd2: "bg-neutral-300 p-4 rounded-lg",
    cd3: "bg-neutral-400 p-4 rounded-lg",
    cd4: "bg-neutral-500 p-4 rounded-lg",
    H2: Fonts.f1.H2,
    H2size: "text-6xl",
    fontP: Fonts.f1.fontP,
    ftPdf: `absolute top-0 right-0 w-3/5`,
    fbPdf: `absolute bottom-0 left-0 w-3/5`,
    fcPdf: `z-10 text-center p-20 w-full text-black space-y-8 h-full flex flex-col justify-center`,
    H2Pdf: "text-4xl",
    whiteBg: "p-2 mx-4 bg-white opacity-80 z-10 rounded-lg",
  },
  theme69: {
    bg: `${process.env.REACT_APP_THEMES_URL}/bg69.jpg`,
    ft: `${process.env.REACT_APP_THEMES_URL}/ft69.png`,
    fb: `${process.env.REACT_APP_THEMES_URL}/fb69.png`,
    fc: `${process.env.REACT_APP_THEMES_URL}/fc69.png`,
    ftStyle: `absolute top-0 left-0 w-2/5 sm:w-1/4 md:w-auto md:h-3/4`,
    fbStyle: `absolute bottom-0 right-0 w-2/5 sm:w-1/4 md:w-auto md:h-3/4`,
    fcStyle: `z-10 text-center p-20 md:p-44 md:w-1/2 sm:w-2/3 w-full text-black space-y-32 sm:space-y-8 h-full sm:h-4/5 flex flex-col justify-center`,
    tStyle: `text-center p-10 md:px-20 md:py-10 border border-neutral-500`,
    xTopStyle: -100,
    xBottomStyle: 100,
    centerText: `text-black`,
    textColor: `text-black`,
    themeColor: 'bg-neutral-50',
    cd1: "bg-neutral-200 p-4 rounded-lg",
    cd2: "bg-neutral-300 p-4 rounded-lg",
    cd3: "bg-neutral-400 p-4 rounded-lg",
    cd4: "bg-neutral-500 p-4 rounded-lg",
    H2: Fonts.f13.H2,
    H2size: "text-6xl",
    fontP: Fonts.f13.fontP,
    ftPdf: `absolute top-0 left-0 w-1/4`,
    fbPdf: `absolute bottom-0 right-0 w-1/4`,
    fcPdf: `z-10 text-center p-20 w-3/4 text-black space-y-28 flex flex-col justify-center`,
    H2Pdf: "text-4xl",
    whiteBg: "p-2 mx-4 bg-white opacity-80 z-10 rounded-lg",
  },
  theme70: {
    bg: `${process.env.REACT_APP_THEMES_URL}/bg70.jpg`,
    ft: `${process.env.REACT_APP_THEMES_URL}/ft70.png`,
    fb: `${process.env.REACT_APP_THEMES_URL}/fb70.png`,
    fc: '',
    ftStyle: `absolute top-28 sm:top-5 left-50 sm:w-2/3 md:w-1/2`,
    fbStyle: `absolute bottom-28 sm:bottom-5 right-50 sm:w-2/3 md:w-1/2`,
    fcStyle: `text-center p-20 md:p-44 md:w-1/2 sm:w-2/3 w-5/6 text-black space-y-8 h-full md:h-4/5 flex flex-col justify-center`,
    tStyle: `text-center p-10 md:px-20 md:py-10 border border-neutral-600`,
    xTopStyle: -100,
    xBottomStyle: 100,
    centerText: `text-black`,
    textColor: `text-black`,
    themeColor: 'bg-neutral-50',
    cd1: "bg-neutral-200 p-4 rounded-lg",
    cd2: "bg-neutral-300 p-4 rounded-lg",
    cd3: "bg-neutral-400 p-4 rounded-lg",
    cd4: "bg-neutral-500 p-4 rounded-lg",
    H2: Fonts.f13.H2,
    H2size: "text-6xl",
    fontP: Fonts.f13.fontP,
    ftPdf: `absolute top-10 left-50`,
    fbPdf: `absolute bottom-10 right-50`,
    fcPdf: `text-center p-20 w-5/6 text-black space-y-8 h-full flex flex-col justify-center`,
    H2Pdf: "text-4xl",
    whiteBg: "p-2 mx-4 bg-white opacity-80 z-10 rounded-lg",
  },
  theme71: {
    bg: `${process.env.REACT_APP_THEMES_URL}/bg71.jpg`,
    ft: `${process.env.REACT_APP_THEMES_URL}/ft71.png`,
    fb: `${process.env.REACT_APP_THEMES_URL}/fb71.png`,
    fc: `${process.env.REACT_APP_THEMES_URL}/fc71.png`,
    ftStyle: `absolute top-0 right-0 w-1/2 sm:w-1/3 md:w-auto md:h-3/4`,
    fbStyle: `absolute bottom-0 left-0 w-1/2 sm:w-1/3 md:w-auto md:h-3/4`,
    fcStyle: `z-10 text-center p-20 md:p-44 md:w-1/2 sm:w-2/3 w-full text-black space-y-32 sm:space-y-8 h-full sm:h-4/5 flex flex-col justify-center`,
    tStyle: `text-center p-10 md:px-20 md:py-10 border border-stone-500`,
    xTopStyle: 100,
    xBottomStyle: -100,
    centerText: `text-black`,
    textColor: `text-black`,
    themeColor: 'bg-stone-100',
    cd1: "bg-stone-200 p-4 rounded-lg",
    cd2: "bg-stone-300 p-4 rounded-lg",
    cd3: "bg-stone-400 p-4 rounded-lg",
    cd4: "bg-stone-500 p-4 rounded-lg",
    H2: Fonts.f1.H2,
    H2size: "text-6xl",
    fontP: Fonts.f1.fontP,
    ftPdf: `absolute top-0 right-0 w-1/3`,
    fbPdf: `absolute bottom-0 left-0 w-1/3`,
    fcPdf: `z-10 text-center p-20 w-3/4 text-black space-y-28 h-full flex flex-col justify-center`,
    H2Pdf: "text-4xl",
    whiteBg: "p-2 mx-4 bg-white opacity-80 z-10 rounded-lg",
  },
  theme72: {
    bg: `${process.env.REACT_APP_THEMES_URL}/bg72.jpg`,
    ft: `${process.env.REACT_APP_THEMES_URL}/ft72.png`,
    fb: `${process.env.REACT_APP_THEMES_URL}/fb72.png`,
    fc: `${process.env.REACT_APP_THEMES_URL}/fc72.png`,
    ftStyle: `absolute top-0 left-0 w-3/4 sm:w-1/2 md:w-auto md:h-1/2`,
    fbStyle: `absolute bottom-0 right-0 w-3/4 sm:w-1/2 md:w-auto md:h-1/2`,
    fcStyle: `z-10 text-center p-20 md:p-44 md:w-1/2 sm:w-2/3 w-3/4 text-neutral-100 space-y-8 sm:space-y-8 h-full sm:h-4/5 flex flex-col justify-center`,
    tStyle: `text-center p-10 md:px-20 md:py-10 border border-neutral-500`,
    xTopStyle: -100,
    xBottomStyle: 100,
    centerText: `text-neutral-100`,
    textColor: `text-neutral-100`,
    themeColor: 'bg-neutral-700',
    cd1: "bg-neutral-200 p-4 rounded-lg",
    cd2: "bg-neutral-300 p-4 rounded-lg",
    cd3: "bg-neutral-400 p-4 rounded-lg",
    cd4: "bg-neutral-500 p-4 rounded-lg",
    H2: Fonts.f2.H2,
    H2size: "text-5xl",
    fontP: Fonts.f2.fontP,
    ftPdf: `absolute top-0 left-0 w-3/4`,
    fbPdf: `absolute bottom-0 right-0 w-3/4`,
    fcPdf: `z-10 text-center p-20 w-3/4 text-neutral-100 space-y-8 h-full flex flex-col justify-center`,
    H2Pdf: "text-4xl",
    whiteBg: "p-2 mx-4 bg-neutral-700 opacity-80 z-10 rounded-lg",
  },
  theme73: {
    bg: `${process.env.REACT_APP_THEMES_URL}/bg73.jpg`,
    ft: `${process.env.REACT_APP_THEMES_URL}/ft73.png`,
    fb: `${process.env.REACT_APP_THEMES_URL}/fb73.png`,
    fc: `${process.env.REACT_APP_THEMES_URL}/fc73.png`,
    ftStyle: `absolute top-0 left-0 w-3/4 sm:w-auto sm:h-4/5`,
    fbStyle: `absolute bottom-0 right-0 w-3/4 sm:w-auto sm:h-4/5`,
    fcStyle: `z-10 text-center p-20 md:p-44 md:w-1/2 sm:w-2/3 w-3/4 text-neutral-100 space-y-8 sm:space-y-8 h-full sm:h-4/5 flex flex-col justify-center`,
    tStyle: `text-center p-10 md:px-20 md:py-10 border border-neutral-500`,
    xTopStyle: -100,
    xBottomStyle: 100,
    centerText: `text-neutral-100`,
    textColor: `text-neutral-100`,
    themeColor: 'bg-neutral-600',
    cd1: "bg-neutral-200 p-4 rounded-lg",
    cd2: "bg-neutral-300 p-4 rounded-lg",
    cd3: "bg-neutral-400 p-4 rounded-lg",
    cd4: "bg-neutral-500 p-4 rounded-lg",
    H2: Fonts.f7.H2,
    H2size: "text-5xl",
    fontP: Fonts.f7.fontP,
    ftPdf: `absolute top-0 left-0 w-3/4`,
    fbPdf: `absolute bottom-0 right-0 w-3/4`,
    fcPdf: `z-10 text-center p-20 w-3/4 text-neutral-100 space-y-8 h-full flex flex-col justify-center`,
    H2Pdf: "text-4xl",
    whiteBg: "p-2 mx-4 bg-neutral-600 opacity-80 z-10 rounded-lg",
  },
  theme74: {
    bg: `${process.env.REACT_APP_THEMES_URL}/bg74.jpg`,
    ft: `${process.env.REACT_APP_THEMES_URL}/ft74.png`,
    fb: '',
    fc: `${process.env.REACT_APP_THEMES_URL}/fc74.png`,
    ftStyle: `absolute top-0 right-0 w-3/4 sm:w-3/5 md:w-1/2`,
    fbStyle: `absolute bottom-0 left-0 w-3/4 sm:w-1/2`,
    fcStyle: `z-10 text-center p-20 md:p-44 md:w-1/2 sm:w-2/3 w-full text-emerald-300 space-y-8 sm:space-y-8 h-full sm:h-4/5 flex flex-col justify-center`,
    tStyle: `text-center p-10 md:px-20 md:py-10 border border-neutral-500`,
    xTopStyle: 100,
    xBottomStyle: -100,
    centerText: `text-emerald-300`,
    textColor: `text-emerald-300`,
    themeColor: 'bg-neutral-700',
    cd1: "bg-neutral-200 p-4 rounded-lg",
    cd2: "bg-neutral-300 p-4 rounded-lg",
    cd3: "bg-neutral-400 p-4 rounded-lg",
    cd4: "bg-neutral-500 p-4 rounded-lg",
    H2: Fonts.f1.H2,
    H2size: "text-5xl",
    fontP: Fonts.f1.fontP,
    ftPdf: `absolute top-0 right-0 w-3/4`,
    fbPdf: `absolute bottom-0 left-0 w-3/4`,
    fcPdf: `z-10 text-center p-20 w-3/4 text-emerald-300 space-y-8 h-full flex flex-col justify-center`,
    H2Pdf: "text-4xl",
    whiteBg: "p-2 mx-4 bg-neutral-700 opacity-80 z-10 rounded-lg",
  },
  theme75: {
    bg: `${process.env.REACT_APP_THEMES_URL}/bg75.jpg`,
    ft: `${process.env.REACT_APP_THEMES_URL}/ft75.png`,
    fb: `${process.env.REACT_APP_THEMES_URL}/fb75.png`,
    fc: `${process.env.REACT_APP_THEMES_URL}/fc75.png`,
    ftStyle: `absolute top-0 left-0 w-3/4 sm:w-2/5 md:w-1/4`,
    fbStyle: `absolute bottom-0 right-0 w-3/4 sm:w-2/5 md:w-1/4`,
    fcStyle: `z-10 text-center p-20 md:p-44 md:w-1/2 sm:w-2/3 w-full text-yellow-200 space-y-8 sm:space-y-8 h-full sm:h-4/5 flex flex-col justify-center`,
    tStyle: `text-center p-10 md:px-20 md:py-10 border border-yellow-500`,
    xTopStyle: -100,
    xBottomStyle: 100,
    centerText: `text-yellow-200`,
    textColor: `text-yellow-200`,
    themeColor: 'bg-neutral-800',
    cd1: "bg-yellow-50 p-4 rounded-lg",
    cd2: "bg-yellow-100 p-4 rounded-lg",
    cd3: "bg-yellow-200 p-4 rounded-lg",
    cd4: "bg-yellow-300 p-4 rounded-lg",
    H2: Fonts.f2.H2,
    H2size: "text-5xl",
    fontP: Fonts.f2.fontP,
    ftPdf: `absolute top-0 left-0 w-1/2`,
    fbPdf: `absolute bottom-0 right-0 w-1/2`,
    fcPdf: `z-10 text-center p-20 w-full text-yellow-200 space-y-8 h-full flex flex-col justify-center`,
    H2Pdf: "text-4xl",
    whiteBg: "p-2 mx-4 bg-neutral-800 opacity-80 z-10 rounded-lg",
  },
  theme76: {
    bg: `${process.env.REACT_APP_THEMES_URL}/bg76.jpg`,
    ft: `${process.env.REACT_APP_THEMES_URL}/ft76.png`,
    fb: `${process.env.REACT_APP_THEMES_URL}/fb76.png`,
    fc: `${process.env.REACT_APP_THEMES_URL}/fc76.png`,
    ftStyle: `absolute top-0 right-0 w-3/4 sm:w-2/5 md:w-1/4`,
    fbStyle: `absolute bottom-0 left-0 w-3/4 sm:w-2/5 md:w-1/4`,
    fcStyle: `text-center p-20 md:p-44 md:w-1/2 sm:w-2/3 w-full text-yellow-200 space-y-8 sm:space-y-8 h-full sm:h-4/5 flex flex-col justify-center`,
    tStyle: `text-center p-10 md:px-20 md:py-10 border border-yellow-500`,
    xTopStyle: 100,
    xBottomStyle: -100,
    centerText: `text-yellow-200`,
    textColor: `text-yellow-200`,
    themeColor: 'bg-neutral-800',
    cd1: "bg-yellow-50 p-4 rounded-lg",
    cd2: "bg-yellow-100 p-4 rounded-lg",
    cd3: "bg-yellow-200 p-4 rounded-lg",
    cd4: "bg-yellow-300 p-4 rounded-lg",
    H2: Fonts.f1.H2,
    H2size: "text-5xl",
    fontP: Fonts.f1.fontP,
    ftPdf: `absolute top-0 right-0 w-1/2`,
    fbPdf: `absolute bottom-0 left-0 w-1/2`,
    fcPdf: `text-center p-20 w-full text-yellow-200 space-y-8 h-full flex flex-col justify-center`,
    H2Pdf: "text-4xl",
    whiteBg: "p-2 mx-4 bg-neutral-800 opacity-80 z-10 rounded-lg",
  },
  theme77: {
    bg: `${process.env.REACT_APP_THEMES_URL}/bg77.jpg`,
    ft: `${process.env.REACT_APP_THEMES_URL}/ft77.png`,
    fb: `${process.env.REACT_APP_THEMES_URL}/fb77.png`,
    fc: '',
    ftStyle: `absolute top-0 left-50 sm:w-full md:-top-32 md:w-full`,
    fbStyle: `absolute bottom-0 right-50 sm:w-full md:w-full`,
    fcStyle: `text-center p-20 md:p-44 md:w-1/2 sm:w-2/3 w-5/6 text-black space-y-8 h-full md:h-4/5 flex flex-col justify-center`,
    tStyle: `text-center p-10 md:px-20 md:py-10 border border-gray-600`,
    xTopStyle: -100,
    xBottomStyle: 100,
    centerText: `text-black`,
    textColor: `text-black`,
    themeColor: 'bg-gray-50',
    cd1: "bg-gray-200 p-4 rounded-lg",
    cd2: "bg-gray-300 p-4 rounded-lg",
    cd3: "bg-gray-400 p-4 rounded-lg",
    cd4: "bg-gray-500 p-4 rounded-lg",
    H2: Fonts.f7.H2,
    H2size: "text-6xl",
    fontP: Fonts.f7.fontP,
    ftPdf: `absolute top-0 left-50 w-full`,
    fbPdf: `absolute bottom-0 right-50 w-full`,
    fcPdf: `text-center p-20 w-5/6 text-black space-y-8 h-full flex flex-col justify-center`,
    H2Pdf: "text-4xl",
    whiteBg: "p-2 mx-4 bg-white opacity-80 z-10 rounded-lg",
  },
  theme78: {
    bg: `${process.env.REACT_APP_THEMES_URL}/bg78.jpg`,
    ft: `${process.env.REACT_APP_THEMES_URL}/ft78.png`,
    fb: `${process.env.REACT_APP_THEMES_URL}/fb78.png`,
    fc: `${process.env.REACT_APP_THEMES_URL}/fc78.png`,
    ftStyle: `absolute top-0 right-50 sm:w-full md:-top-32 md:w-full`,
    fbStyle: `absolute bottom-0 left-50 sm:w-full md:-bottom-40 md:w-full`,
    fcStyle: `text-center p-20 md:p-44 md:w-1/2 sm:w-2/3 w-5/6 text-yellow-100 space-y-8 h-full md:h-4/5 flex flex-col justify-center`,
    tStyle: `text-center p-10 md:px-20 md:py-10 border border-yellow-600`,
    xTopStyle: 100,
    xBottomStyle: -100,
    centerText: `text-yellow-100`,
    textColor: `text-yellow-100`,
    themeColor: 'bg-neutral-800',
    cd1: "bg-yellow-200 p-4 rounded-lg",
    cd2: "bg-yellow-300 p-4 rounded-lg",
    cd3: "bg-yellow-400 p-4 rounded-lg",
    cd4: "bg-yellow-500 p-4 rounded-lg",
    H2: Fonts.f1.H2,
    H2size: "text-6xl",
    fontP: Fonts.f1.fontP,
    ftPdf: `absolute top-0 right-50 w-full`,
    fbPdf: `absolute bottom-0 left-50 w-full`,
    fcPdf: `text-center p-20 w-5/6 text-yellow-100 space-y-8 h-full flex flex-col justify-center`,
    H2Pdf: "text-4xl",
    whiteBg: "p-2 mx-4 bg-neutral-800 opacity-80 z-10 rounded-lg",
  },
  theme79: {
    bg: `${process.env.REACT_APP_THEMES_URL}/bg79.jpg`,
    ft: `${process.env.REACT_APP_THEMES_URL}/ft79.png`,
    fb: `${process.env.REACT_APP_THEMES_URL}/fb79.png`,
    fc: `${process.env.REACT_APP_THEMES_URL}/fc79.png`,
    ftStyle: `absolute top-0 left-0 w-1/2 sm:w-2/5 md:w-1/3`,
    fbStyle: `absolute top-0 right-0 w-1/2 sm:w-2/5 md:w-1/3`,
    fcStyle: `text-center p-20 pb-32 md:p-44 w-full md:w-2/3 sm:w-2/3 text-black space-y-8 h-full flex flex-col justify-center`,
    tStyle: `text-center p-10 md:px-20 md:py-10 border border-gray-600`,
    xTopStyle: -100,
    xBottomStyle: 100,
    centerText: `text-black`,
    textColor: `text-black`,
    themeColor: 'bg-gray-100',
    cd1: "bg-gray-200 p-4 rounded-lg",
    cd2: "bg-gray-300 p-4 rounded-lg",
    cd3: "bg-gray-400 p-4 rounded-lg",
    cd4: "bg-gray-500 p-4 rounded-lg",
    H2: Fonts.f2.H2,
    H2size: "text-6xl",
    fontP: Fonts.f2.fontP,
    ftPdf: `absolute top-0 left-0 w-1/2`,
    fbPdf: `absolute top-0 right-0 w-1/2`,
    fcPdf: `text-center p-20 pb-32 w-full text-black space-y-8 h-full flex flex-col justify-center`,
    H2Pdf: "text-4xl",
    whiteBg: "p-2 mx-4 bg-white opacity-80 z-10 rounded-lg",
  },
  theme80: {
    bg: `${process.env.REACT_APP_THEMES_URL}/bg80.jpg`,
    ft: '',
    fb: '',
    fc: `${process.env.REACT_APP_THEMES_URL}/fc80.png`,
    ftStyle: `absolute top-0 right-0 sm:w-2/3 md:w-2/3 w-full`,
    fbStyle: `absolute bottom-0 left-0 sm:w-2/3 md:w-2/3 w-full`,
    fcStyle: `text-center p-20 md:p-44 md:w-1/2 sm:w-full w-full text-black space-y-8 h-screen flex flex-col justify-center`,
    tStyle: `text-center p-10 md:px-20 md:py-10 border border-amber-500`,
    xTopStyle: '',
    xBottomStyle: '',
    themeColor: 'bg-stone-100',
    cd1: "bg-orange-100 p-4 rounded-lg",
    cd2: "bg-orange-200 p-4 rounded-lg",
    cd3: "bg-orange-300 p-4 rounded-lg",
    cd4: "bg-orange-400 p-4 rounded-lg",
    H2: Fonts.f13.H2,
    H2size: "text-5xl",
    fontP: Fonts.f13.fontP,
    ftPdf: `absolute top-0 right-0 w-full`,
    fbPdf: `absolute bottom-0 left-0 w-full`,
    fcPdf: `text-center p-20 w-full text-black space-y-8 h-screen flex flex-col justify-center`,
    H2Pdf: "text-4xl",
    whiteBg: "p-2 mx-4 bg-white opacity-80 z-10 rounded-lg",
  },
  theme81: {
    bg: `${process.env.REACT_APP_THEMES_URL}/bg81.jpg`,
    ft: `${process.env.REACT_APP_THEMES_URL}/ft81.png`,
    fb: `${process.env.REACT_APP_THEMES_URL}/fb81.png`,
    fc: `${process.env.REACT_APP_THEMES_URL}/fc81.png`,
    ftStyle: `absolute top-0 right-0 w-3/4 sm:w-2/5 md:w-1/3`,
    fbStyle: `absolute bottom-0 left-0 w-3/4 sm:w-2/5 md:w-1/3`,
    fcStyle: `text-center p-20 md:p-44 w-full md:w-1/2 sm:w-2/3 text-yellow-100 space-y-8 h-full md:h-4/5 flex flex-col justify-center`,
    tStyle: `text-center p-10 md:px-20 md:py-10 border border-yellow-600`,
    xTopStyle: 100,
    xBottomStyle: -100,
    centerText: `text-yellow-100`,
    textColor: `text-yellow-100`,
    themeColor: 'bg-neutral-900',
    cd1: "bg-yellow-200 p-4 rounded-lg",
    cd2: "bg-yellow-300 p-4 rounded-lg",
    cd3: "bg-yellow-400 p-4 rounded-lg",
    cd4: "bg-yellow-500 p-4 rounded-lg",
    H2: Fonts.f1.H2,
    H2size: "text-6xl",
    fontP: Fonts.f1.fontP,
    ftPdf: `absolute top-0 right-0 w-1/2`,
    fbPdf: `absolute bottom-0 left-0 w-1/2`,
    fcPdf: `text-center p-20 w-full text-yellow-100 space-y-8 h-full flex flex-col justify-center`,
    H2Pdf: "text-4xl",
    whiteBg: "p-2 mx-4 bg-neutral-900 opacity-80 z-10 rounded-lg",
  },
  theme82: {
    bg: `${process.env.REACT_APP_THEMES_URL}/bg82.jpg`,
    ft: `${process.env.REACT_APP_THEMES_URL}/ft82.png`,
    fb: `${process.env.REACT_APP_THEMES_URL}/fb82.png`,
    fc: `${process.env.REACT_APP_THEMES_URL}/fc82.png`,
    ftStyle: `absolute top-0 left-0 w-full sm:w-3/5 md:w-1/3`,
    fbStyle: `absolute bottom-0 right-0 w-full sm:w-3/5 md:w-1/3`,
    fcStyle: `text-center p-20 md:p-44 w-5/6 sm:w-1/2 md:w-1/2 text-yellow-100 space-y-8 h-full md:h-4/5 flex flex-col justify-center`,
    tStyle: `text-center p-10 md:px-20 md:py-10 border border-yellow-600`,
    xTopStyle: -100,
    xBottomStyle: 100,
    centerText: `text-yellow-100`,
    textColor: `text-yellow-100`,
    themeColor: 'bg-neutral-900',
    cd1: "bg-yellow-200 p-4 rounded-lg",
    cd2: "bg-yellow-300 p-4 rounded-lg",
    cd3: "bg-yellow-400 p-4 rounded-lg",
    cd4: "bg-yellow-500 p-4 rounded-lg",
    H2: Fonts.f1.H2,
    H2size: "text-6xl",
    fontP: Fonts.f1.fontP,
    ftPdf: `absolute top-0 left-0 w-full`,
    fbPdf: `absolute bottom-0 right-0 w-full`,
    fcPdf: `text-center p-20 w-5/6 text-yellow-100 space-y-8 h-full flex flex-col justify-center`,
    H2Pdf: "text-4xl",
    whiteBg: "p-2 mx-4 bg-neutral-900 opacity-80 z-10 rounded-lg",
  },
  theme83: {
    bg: `${process.env.REACT_APP_THEMES_URL}/bg83.jpg`,
    ft: `${process.env.REACT_APP_THEMES_URL}/ft83.png`,
    fb: `${process.env.REACT_APP_THEMES_URL}/fb83.png`,
    fc: '',
    ftStyle: `absolute top-0 left-0 w-1/2 sm:w-1/3 md:w-1/3`,
    fbStyle: `absolute top-0 right-0 w-1/2 sm:w-1/3 md:w-1/3`,
    fcStyle: `text-center p-20 md:p-44 w-5/6 sm:w-1/2 md:w-1/2 text-yellow-100 space-y-8 h-full md:h-4/5 flex flex-col justify-center`,
    tStyle: `text-center p-10 md:px-20 md:py-10 border border-yellow-600`,
    xTopStyle: -100,
    xBottomStyle: 100,
    centerText: `text-yellow-100`,
    textColor: `text-yellow-100`,
    themeColor: 'bg-slate-700',
    cd1: "bg-yellow-100 p-4 rounded-lg",
    cd2: "bg-yellow-200 p-4 rounded-lg",
    cd3: "bg-yellow-300 p-4 rounded-lg",
    cd4: "bg-yellow-400 p-4 rounded-lg",
    H2: Fonts.f1.H2,
    H2size: "text-6xl",
    fontP: Fonts.f1.fontP,
    ftPdf: `absolute top-0 left-0 w-1/2`,
    fbPdf: `absolute top-0 right-0 w-1/2`,
    fcPdf: `text-center p-20 w-5/6 text-yellow-100 space-y-8 h-full flex flex-col justify-center`,
    H2Pdf: "text-4xl",
    whiteBg: "p-2 mx-4 bg-slate-700 opacity-80 z-10 rounded-lg",
  },
  theme84: {
    bg: `${process.env.REACT_APP_THEMES_URL}/bg84.jpg`,
    ft: `${process.env.REACT_APP_THEMES_URL}/ft84.png`,
    fb: `${process.env.REACT_APP_THEMES_URL}/fb84.png`,
    fc: '',
    ftStyle: `absolute top-0 left-0 w-2/3 sm:w-1/2 md:w-1/3`,
    fbStyle: `absolute bottom-0 right-0 w-2/3 sm:w-1/2 md:w-1/3`,
    fcStyle: `text-center p-20 md:p-44 w-5/6 sm:w-1/2 md:w-1/2 text-gray-800 space-y-8 h-full md:h-4/5 flex flex-col justify-center`,
    tStyle: `text-center p-10 md:px-20 md:py-10 border border-yellow-600`,
    xTopStyle: -100,
    xBottomStyle: 100,
    centerText: `text-gray-800`,
    textColor: `text-gray-800`,
    themeColor: 'bg-gray-100',
    cd1: "bg-gray-200 p-4 rounded-lg",
    cd2: "bg-gray-300 p-4 rounded-lg",
    cd3: "bg-gray-400 p-4 rounded-lg",
    cd4: "bg-gray-500 p-4 rounded-lg",
    H2: Fonts.f7.H2,
    H2size: "text-6xl",
    fontP: Fonts.f7.fontP,
    ftPdf: `absolute top-0 left-0 w-2/3`,
    fbPdf: `absolute bottom-0 right-0 w-2/3`,
    fcPdf: `text-center p-20 w-5/6 text-gray-800 space-y-8 h-full flex flex-col justify-center`,
    H2Pdf: "text-4xl",
    whiteBg: "p-2 mx-4 bg-white opacity-80 z-10 rounded-lg",
  },
  theme85: {
    bg: `${process.env.REACT_APP_THEMES_URL}/bg85.jpg`,
    ft: `${process.env.REACT_APP_THEMES_URL}/ft85.png`,
    fb: `${process.env.REACT_APP_THEMES_URL}/fb85.png`,
    fc: '',
    ftStyle: `absolute top-0 right-0 w-full sm:w-2/3 md:w-2/5`,
    fbStyle: `absolute bottom-0 left-0 w-full sm:w-2/3 md:w-2/5`,
    fcStyle: `text-center p-20 md:p-44 w-5/6 sm:w-1/2 md:w-1/2 text-yellow-100 space-y-8 h-full md:h-4/5 flex flex-col justify-center`,
    tStyle: `text-center p-10 md:px-20 md:py-10 border border-yellow-100`,
    xTopStyle: 100,
    xBottomStyle: -100,
    centerText: `text-yellow-100`,
    textColor: `text-yellow-100`,
    themeColor: 'bg-slate-900',
    cd1: "bg-yellow-100 p-4 rounded-lg",
    cd2: "bg-yellow-200 p-4 rounded-lg",
    cd3: "bg-yellow-300 p-4 rounded-lg",
    cd4: "bg-yellow-400 p-4 rounded-lg",
    H2: Fonts.f2.H2,
    H2size: "text-6xl",
    fontP: Fonts.f2.fontP,
    ftPdf: `absolute top-0 right-0 w-full`,
    fbPdf: `absolute bottom-0 left-0 w-full`,
    fcPdf: `text-center p-20 w-5/6 text-yellow-100 space-y-8 h-full flex flex-col justify-center`,tStyle: `text-center p-10 md:px-20 md:py-10 border border-yellow-100`,
    H2Pdf: "text-4xl",
    whiteBg: "p-2 mx-4 bg-slate-900 opacity-80 z-10 rounded-lg",
  },
  theme86: {
    bg: `${process.env.REACT_APP_THEMES_URL}/bg86.jpg`,
    ft: `${process.env.REACT_APP_THEMES_URL}/ft86.png`,
    fb: `${process.env.REACT_APP_THEMES_URL}/fb86.png`,
    fc: `${process.env.REACT_APP_THEMES_URL}/fc86.png`,
    ftStyle: `absolute top-0 right-0 w-full sm:w-3/5 md:w-1/3`,
    fbStyle: `absolute bottom-0 left-0 w-full sm:w-3/5 md:w-1/3`,
    fcStyle: `text-center p-20 md:p-44 w-5/6 sm:w-1/2 md:w-1/2 text-slate-800 space-y-8 h-full md:h-4/5 flex flex-col justify-center`,
    tStyle: `text-center p-10 md:px-20 md:py-10 border border-slate-800`,
    xTopStyle: 100,
    xBottomStyle: -100,
    centerText: `text-slate-800`,
    textColor: `text-slate-800`,
    themeColor: 'bg-slate-100',
    cd1: "bg-slate-200 p-4 rounded-lg",
    cd2: "bg-slate-300 p-4 rounded-lg",
    cd3: "bg-slate-400 p-4 rounded-lg",
    cd4: "bg-slate-500 p-4 rounded-lg",
    H2: Fonts.f1.H2,
    H2size: "text-6xl",
    fontP: Fonts.f1.fontP,
    ftPdf: `absolute top-0 right-0 w-full`,
    fbPdf: `absolute bottom-0 left-0 w-3/4`,
    fcPdf: `text-center p-28 w-5/6 text-slate-800 space-y-8 h-full flex flex-col justify-center`,tStyle: `text-center p-10 md:px-20 md:py-10 border border-slate-800`,
    H2Pdf: "text-4xl",
    whiteBg: "p-2 mx-4 bg-white opacity-80 z-10 rounded-lg", 
  },
  theme87: {
    bg: `${process.env.REACT_APP_THEMES_URL}/bg87.jpg`,
    ft: `${process.env.REACT_APP_THEMES_URL}/ft87.png`,
    fb: `${process.env.REACT_APP_THEMES_URL}/fb87.png`,
    fc: `${process.env.REACT_APP_THEMES_URL}/fc87.png`,
    ftStyle: `absolute top-0 right-0 w-full sm:w-3/5 md:w-1/3`,
    fbStyle: `absolute bottom-0 left-0 w-full sm:w-3/5 md:w-1/3`,
    fcStyle: `text-center p-20 md:p-44 w-5/6 sm:w-1/2 md:w-1/2 text-slate-800 space-y-8 h-full md:h-4/5 flex flex-col justify-center`,
    tStyle: `text-center p-10 md:px-20 md:py-10 border border-slate-800`,
    xTopStyle: 100,
    xBottomStyle: -100,
    centerText: `text-slate-800`,
    textColor: `text-slate-800`,
    themeColor: 'bg-slate-100',
    cd1: "bg-slate-200 p-4 rounded-lg",
    cd2: "bg-slate-300 p-4 rounded-lg",
    cd3: "bg-slate-400 p-4 rounded-lg",
    cd4: "bg-slate-500 p-4 rounded-lg",
    H2: Fonts.f2.H2,
    H2size: "text-6xl",
    fontP: Fonts.f2.fontP,
    ftPdf: `absolute top-0 right-0 w-3/4`,
    fbPdf: `absolute bottom-0 left-0 w-3/4`,
    fcPdf: `text-center p-20 w-5/6 text-slate-800 space-y-8 h-full flex flex-col justify-center`,
    H2Pdf: "text-4xl",
    whiteBg: "p-2 mx-4 bg-white opacity-80 z-10 rounded-lg",
  },
  theme88: {
    bg: `${process.env.REACT_APP_THEMES_URL}/bg88.jpg`,
    ft: '',
    fb: '',
    fc: `${process.env.REACT_APP_THEMES_URL}/fc88.png`,
    ftStyle: `absolute top-0 right-0 sm:w-2/3 md:w-2/3 w-full`,
    fbStyle: `absolute bottom-0 left-0 sm:w-2/3 md:w-2/3 w-full`,
    fcStyle: `text-center p-20 md:p-44 md:w-1/2 sm:w-full w-full text-blue-100 space-y-8 h-screen flex flex-col justify-center`,
    tStyle: `text-center p-10 md:px-20 md:py-10 border border-slate-700`,
    xTopStyle: '',
    xBottomStyle: '',
    themeColor: 'bg-stone-100',
    cd1: "bg-slate-100 p-4 rounded-lg",
    cd2: "bg-slate-200 p-4 rounded-lg",
    cd3: "bg-slate-300 p-4 rounded-lg",
    cd4: "bg-slate-400 p-4 rounded-lg",
    H2: Fonts.f1.H2,
    H2size: "text-5xl",
    fontP: Fonts.f1.fontP,
    ftPdf: `absolute top-0 right-0 w-full`,
    fbPdf: `absolute bottom-0 left-0 w-full`,
    fcPdf: `text-center p-20 w-full text-blue-100 space-y-8 h-screen flex flex-col justify-center`,
    H2Pdf: "text-4xl",
    whiteBg: "p-2 mx-4 bg-white opacity-80 z-10 rounded-lg",
  },
  theme89: {
    bg: `${process.env.REACT_APP_THEMES_URL}/bg89.jpg`,
    ft: `${process.env.REACT_APP_THEMES_URL}/ft89.png`,
    fb: `${process.env.REACT_APP_THEMES_URL}/fb89.png`,
    fc: `${process.env.REACT_APP_THEMES_URL}/fc89.png`,
    ftStyle: `absolute top-0 left-0 w-1/2 sm:w-1/2 md:w-1/3`,
    fbStyle: `absolute top-0 right-0 w-1/2 sm:w-1/2 md:w-1/3`,
    fcStyle: `text-center p-20 md:p-44 w-full sm:w-3/4 md:w-auto text-slate-800 space-y-8 h-full md:h-screen flex flex-col justify-center`,
    tStyle: `text-center p-10 md:px-20 md:py-10 border border-slate-800`,
    xTopStyle: -100,
    xBottomStyle: 100,
    centerText: `text-slate-800`,
    textColor: `text-slate-800`,
    themeColor: 'bg-slate-200',
    cd1: "bg-slate-200 p-4 rounded-lg",
    cd2: "bg-slate-300 p-4 rounded-lg",
    cd3: "bg-slate-400 p-4 rounded-lg",
    cd4: "bg-slate-500 p-4 rounded-lg",
    H2: Fonts.f13.H2,
    H2size: "text-6xl",
    fontP: Fonts.f13.fontP,
    ftPdf: `absolute top-0 left-0 w-1/2`,
    fbPdf: `absolute top-0 right-0 w-1/2`,
    fcPdf: `text-center p-20 w-full text-slate-800 space-y-8 h-full flex flex-col justify-center`,tStyle: `text-center p-10 md:px-20 md:py-10 border border-slate-800`,
    H2Pdf: "text-4xl",
    whiteBg: "p-2 mx-4 bg-white opacity-80 z-10 rounded-lg",
  },
  theme90: {
    bg: `${process.env.REACT_APP_THEMES_URL}/bg90.jpg`,
    ft: `${process.env.REACT_APP_THEMES_URL}/ft90.png`,
    fb: `${process.env.REACT_APP_THEMES_URL}/fb90.png`,
    fc: `${process.env.REACT_APP_THEMES_URL}/fc90.png`,
    ftStyle: `absolute top-0 left-0 w-1/2 sm:w-1/2 md:w-1/3`,
    fbStyle: `absolute top-0 right-0 w-1/2 sm:w-1/2 md:w-1/3`,
    fcStyle: `text-center p-20 md:p-44 w-full sm:w-3/4 md:w-auto text-slate-800 space-y-8 h-full md:h-screen flex flex-col justify-center`,
    tStyle: `text-center p-10 md:px-20 md:py-10 border border-slate-800`,
    xTopStyle: -100,
    xBottomStyle: 100,
    centerText: `text-slate-800`,
    textColor: `text-slate-800`,
    themeColor: 'bg-blue-100',
    cd1: "bg-blue-200 p-4 rounded-lg",
    cd2: "bg-blue-300 p-4 rounded-lg",
    cd3: "bg-blue-400 p-4 rounded-lg",
    cd4: "bg-blue-500 p-4 rounded-lg",
    H2: Fonts.f2.H2,
    H2size: "text-6xl",
    fontP: Fonts.f2.fontP,
    ftPdf: `absolute top-0 left-0 w-1/2`,
    fbPdf: `absolute top-0 right-0 w-1/2`,
    fcPdf: `text-center p-20 w-full text-slate-800 space-y-8 h-full flex flex-col justify-center`,
    H2Pdf: "text-4xl",
    whiteBg: "p-2 mx-4 bg-white opacity-80 z-10 rounded-lg",
  },
  theme91: {
    bg: `${process.env.REACT_APP_THEMES_URL}/bg91.jpg`,
    ft: `${process.env.REACT_APP_THEMES_URL}/ft91.png`,
    fb: `${process.env.REACT_APP_THEMES_URL}/fb91.png`,
    fc: '',
    ftStyle: `absolute bottom-0 left-0 w-1/2 sm:w-1/3 md:w-1/3`,
    fbStyle: `absolute bottom-0 right-0 w-1/2 sm:w-1/3 md:w-1/3`,
    fcStyle: `text-center p-20 md:p-44 w-full sm:w-3/4 md:w-auto text-yellow-200 space-y-8 h-full md:h-screen flex flex-col justify-center`,
    tStyle: `text-center p-10 md:px-20 md:py-10 border border-yellow-200`,
    xTopStyle: -100,
    xBottomStyle: 100,
    centerText: `text-yellow-200`,
    textColor: `text-yellow-200`,
    themeColor: 'bg-slate-700',
    cd1: "bg-yellow-200 p-4 rounded-lg",
    cd2: "bg-yellow-300 p-4 rounded-lg",
    cd3: "bg-yellow-400 p-4 rounded-lg",
    cd4: "bg-yellow-500 p-4 rounded-lg",
    H2: Fonts.f1.H2,
    H2size: "text-6xl",
    fontP: Fonts.f1.fontP,
    ftPdf: `absolute -bottom-10 left-0 w-1/2`,
    fbPdf: `absolute -bottom-10 right-0 w-1/2`,
    fcPdf: `text-center p-20 w-full text-yellow-200 space-y-8 h-full flex flex-col justify-center`,tStyle: `text-center p-10 md:px-20 md:py-10 border border-yellow-200`,
    H2Pdf: "text-4xl",
    whiteBg: "p-2 mx-4 bg-slate-700 opacity-80 z-10 rounded-lg",
  },
  theme92: {
    bg: `${process.env.REACT_APP_THEMES_URL}/bg92.jpg`,
    ft: `${process.env.REACT_APP_THEMES_URL}/ft92.png`,
    fb: `${process.env.REACT_APP_THEMES_URL}/fb92.png`,
    fc: `${process.env.REACT_APP_THEMES_URL}/fc92.png`,
    ftStyle: `absolute top-0 left-50 w-full md:-top-40`,
    fbStyle: `absolute bottom-0 right-50 w-full md:-bottom-40`,
    fcStyle: `text-center p-20 md:p-44 w-full sm:w-3/4 md:w-auto text-stone-700 space-y-8 h-full md:h-screen flex flex-col justify-center`,
    tStyle: `text-center p-10 md:px-20 md:py-10 border border-stone-700`,
    xTopStyle: -100,
    xBottomStyle: 100,
    centerText: `text-stone-700`,
    textColor: `text-stone-700`,
    themeColor: 'bg-stone-100',
    cd1: "bg-stone-200 p-4 rounded-lg",
    cd2: "bg-stone-300 p-4 rounded-lg",
    cd3: "bg-stone-400 p-4 rounded-lg",
    cd4: "bg-stone-500 p-4 rounded-lg",
    H2: Fonts.f1.H2,
    H2size: "text-6xl",
    fontP: Fonts.f1.fontP,
    ftPdf: `absolute top-0 left-50 w-full`,
    fbPdf: `absolute bottom-0 right-50 w-full`,
    fcPdf: `text-center p-20 w-full text-stone-700 space-y-8 h-full flex flex-col justify-center`,
    H2Pdf: "text-4xl",
    whiteBg: "p-2 mx-4 bg-white opacity-80 z-10 rounded-lg",
  },
  theme93: {
    bg: `${process.env.REACT_APP_THEMES_URL}/bg93.jpg`,
    ft: `${process.env.REACT_APP_THEMES_URL}/ft93.png`,
    fb: `${process.env.REACT_APP_THEMES_URL}/fb93.png`,
    fc: '',
    ftStyle: `absolute top-0 left-50 w-full sm:-top-8 md:-top-32`,
    fbStyle: `absolute bottom-0 right-50 w-full sm:-bottom-12 md:-bottom-52`,
    fcStyle: `text-center p-20 md:p-44 w-full sm:w-3/4 md:w-auto text-yellow-200 space-y-8 h-full md:h-screen flex flex-col justify-center`,
    tStyle: `text-center p-10 md:px-20 md:py-10 border border-yellow-200`,
    xTopStyle: -100,
    xBottomStyle: 100,
    centerText: `text-yellow-200`,
    textColor: `text-yellow-200`,
    themeColor: 'bg-slate-900',
    cd1: "bg-yellow-200 p-4 rounded-lg",
    cd2: "bg-yellow-300 p-4 rounded-lg",
    cd3: "bg-yellow-400 p-4 rounded-lg",
    cd4: "bg-yellow-500 p-4 rounded-lg",
    H2: Fonts.f13.H2,
    H2size: "text-6xl",
    fontP: Fonts.f13.fontP,
    ftPdf: `absolute top-0 left-50 w-full`,
    fbPdf: `absolute bottom-0 right-50 w-full`,
    fcPdf: `text-center p-20 w-full text-yellow-200 space-y-8 h-full flex flex-col justify-center`,
    H2Pdf: "text-4xl",
    whiteBg: "p-2 mx-4 bg-slate-900 opacity-80 z-10 rounded-lg",
  },
  theme94: {
    bg: `${process.env.REACT_APP_THEMES_URL}/bg94.jpg`,
    ft: `${process.env.REACT_APP_THEMES_URL}/ft94.png`,
    fb: `${process.env.REACT_APP_THEMES_URL}/fb94.png`,
    fc: `${process.env.REACT_APP_THEMES_URL}/fc94.png`,
    ftStyle: `absolute top-0 left-0 w-2/3 sm:w-1/2 md:w-1/3`,
    fbStyle: `absolute bottom-0 right-0 w-2/3 sm:w-1/2 md:w-1/3`,
    fcStyle: `text-center p-20 md:p-44 w-5/6 sm:w-3/5 h-full text-yellow-100 space-y-8 flex flex-col justify-center`,
    tStyle: `text-center p-10 md:px-20 md:py-10 border border-yellow-100`,
    xTopStyle: -100,
    xBottomStyle: 100,
    centerText: `text-yellow-100`,
    textColor: `text-yellow-100`,
    themeColor: 'bg-emerald-900',
    cd1: "bg-emerald-200 p-4 rounded-lg",
    cd2: "bg-emerald-300 p-4 rounded-lg",
    cd3: "bg-emerald-400 p-4 rounded-lg",
    cd4: "bg-emerald-500 p-4 rounded-lg",
    H2: Fonts.f2.H2,
    H2size: "text-6xl",
    fontP: Fonts.f2.fontP,
    ftPdf: `absolute top-0 left-0 w-2/3`,
    fbPdf: `absolute bottom-0 right-0 w-2/3`,
    fcPdf: `text-center p-20 w-5/6 text-yellow-100 space-y-8 flex flex-col justify-center`,
    H2Pdf: "text-4xl",
    whiteBg: "p-2 mx-4 bg-emerald-900 opacity-80 z-10 rounded-lg",
  },
  theme95: {
    bg: `${process.env.REACT_APP_THEMES_URL}/bg95.jpg`,
    ft: '',
    fb: '',
    fc: `${process.env.REACT_APP_THEMES_URL}/fc95.png`,
    ftStyle: `absolute top-0 right-0 sm:w-2/3 md:w-2/3 w-full`,
    fbStyle: `absolute bottom-0 left-0 sm:w-2/3 md:w-2/3 w-full`,
    fcStyle: `text-center p-20 md:p-44 md:w-1/2 sm:w-full w-full text-neutral-100 space-y-8 h-screen flex flex-col justify-center`,
    tStyle: `text-center p-10 md:px-20 md:py-10 border border-black`,
    xTopStyle: '',
    xBottomStyle: '',
    themeColor: 'bg-gray-50',
    cd1: "bg-pink-100 p-4 rounded-lg",
    cd2: "bg-pink-200 p-4 rounded-lg",
    cd3: "bg-pink-300 p-4 rounded-lg",
    cd4: "bg-pink-400 p-4 rounded-lg",
    H2: Fonts.f1.H2,
    H2size: "text-5xl",
    fontP: Fonts.f1.fontP,
    ftPdf: `absolute top-0 right-0 w-full`,
    fbPdf: `absolute bottom-0 left-0 w-full`,
    fcPdf: `text-center p-32 w-full text-neutral-100 space-y-8 h-screen flex flex-col justify-center`,
    H2Pdf: "text-4xl",
    whiteBg: "p-2 mx-4 bg-white opacity-80 z-10 rounded-lg",
  },
  theme96: {
    bg: '',
    ft: '',
    fb: '',
    fc: `${process.env.REACT_APP_THEMES_URL}/fc96.png`,
    ftStyle: `absolute top-0 right-0 sm:w-2/3 md:w-2/3 w-full`,
    fbStyle: `absolute bottom-0 left-0 sm:w-2/3 md:w-2/3 w-full`,
    fcStyle: `text-center pr-32 p-20 md:pr-56 md:p-44 w-full md:w-1/2 text-black space-y-8 h-screen flex flex-col justify-center`,
    tStyle: `text-center p-10 md:px-20 md:py-10 border border-black`,
    xTopStyle: '',
    xBottomStyle: '',
    themeColor: 'bg-rose-50',
    cd1: "bg-orange-100 p-4 rounded-lg",
    cd2: "bg-orange-200 p-4 rounded-lg",
    cd3: "bg-orange-300 p-4 rounded-lg",
    cd4: "bg-orange-400 p-4 rounded-lg",
    H2: Fonts.f2.H2,
    H2size: "text-5xl",
    fontP: Fonts.f2.fontP,
    ftPdf: `absolute top-0 right-0 w-full`,
    fbPdf: `absolute bottom-0 left-0 w-full`,
    fcPdf: `text-center pr-32 p-20 w-full text-black space-y-8 h-screen flex flex-col justify-center`,tStyle: `text-center p-10 md:px-20 md:py-10 border border-black`,
    H2Pdf: "text-4xl",
    whiteBg: "p-2 mx-4 bg-white opacity-80 z-10 rounded-lg",
  },
  theme97: {
    bg: `${process.env.REACT_APP_THEMES_URL}/bg97.jpg`,
    ft: '',
    fb: '',
    fc: `${process.env.REACT_APP_THEMES_URL}/fc97.png`,
    ftStyle: `absolute top-0 right-0 sm:w-2/3 md:w-2/3 w-full`,
    fbStyle: `absolute bottom-0 left-0 sm:w-2/3 md:w-2/3 w-full`,
    fcStyle: `text-center p-20 pb-32 md:p-44 w-full md:w-1/2 text-black space-y-4 h-screen flex flex-col justify-center`,
    tStyle: `text-center p-10 md:px-20 md:py-10 border border-black`,
    xTopStyle: '',
    xBottomStyle: '',
    themeColor: 'bg-neutral-100',
    cd1: "bg-yellow-100 p-4 rounded-lg",
    cd2: "bg-yellow-200 p-4 rounded-lg",
    cd3: "bg-yellow-300 p-4 rounded-lg",
    cd4: "bg-yellow-400 p-4 rounded-lg",
    H2: Fonts.f1.H2,
    H2size: "text-5xl",
    fontP: Fonts.f1.fontP,
    ftPdf: `absolute top-0 right-0 w-full`,
    fbPdf: `absolute bottom-0 left-0 w-full`,
    fcPdf: `text-center p-20 pb-32 w-full text-black space-y-4 h-screen flex flex-col justify-center`,
    H2Pdf: "text-4xl",
    whiteBg: "p-2 mx-4 bg-white opacity-80 z-10 rounded-lg",
  },
  theme98: {
    bg: `${process.env.REACT_APP_THEMES_URL}/bg98.jpg`,
    ft: `${process.env.REACT_APP_THEMES_URL}/ft98.png`,
    fb: `${process.env.REACT_APP_THEMES_URL}/fb98.png`,
    fc: '',
    ftStyle: `absolute top-0 right-0 w-3/5 sm:w-1/2 md:w-1/3`,
    fbStyle: `absolute bottom-0 left-0 w-3/5 sm:w-1/2 md:w-1/3`,
    fcStyle: `text-center p-20 md:p-44 w-full sm:w-3/4 md:w-auto text-emerald-800 space-y-8 h-full md:h-screen flex flex-col justify-center`,
    tStyle: `text-center p-10 md:px-20 md:py-10 border border-emerald-800`,
    xTopStyle: 100,
    xBottomStyle: -100,
    centerText: `text-emerald-800`,
    textColor: `text-emerald-800`,
    themeColor: 'bg-neutral-50',
    cd1: "bg-emerald-200 p-4 rounded-lg",
    cd2: "bg-emerald-300 p-4 rounded-lg",
    cd3: "bg-emerald-400 p-4 rounded-lg",
    cd4: "bg-emerald-500 p-4 rounded-lg",
    H2: Fonts.f2.H2,
    H2size: "text-6xl",
    fontP: Fonts.f2.fontP,
    ftPdf: `absolute top-0 right-0 w-3/5`,
    fbPdf: `absolute bottom-0 left-0 w-3/5`,
    fcPdf: `text-center p-20 w-full text-emerald-800 space-y-8 h-full flex flex-col justify-center`,
    H2Pdf: "text-4xl",
    whiteBg: "p-2 mx-4 bg-white opacity-80 z-10 rounded-lg",
  },
  theme99: {
    bg: `${process.env.REACT_APP_THEMES_URL}/bg99.jpg`,
    ft: `${process.env.REACT_APP_THEMES_URL}/ft99.png`,
    fb: `${process.env.REACT_APP_THEMES_URL}/fb99.png`,
    fc: '',
    ftStyle: `absolute top-0 right-0 w-full sm:-top-20 md:w-1/2`,
    fbStyle: `absolute bottom-0 left-0 w-2/3 sm:w-2/5 md:w-1/3`,
    fcStyle: `z-10 text-center p-20 md:p-44 w-full sm:w-3/4 md:w-auto text-black space-y-8 h-full md:h-screen flex flex-col justify-center`,
    tStyle: `text-center p-20 md:px-20 md:py-10 border border-black`,
    xTopStyle: 100,
    xBottomStyle: -100,
    centerText: `text-black`,
    textColor: `text-black`,
    themeColor: 'bg-stone-100',
    cd1: "bg-emerald-200 p-4 rounded-lg",
    cd2: "bg-emerald-300 p-4 rounded-lg",
    cd3: "bg-emerald-400 p-4 rounded-lg",
    cd4: "bg-emerald-500 p-4 rounded-lg",
    H2: Fonts.f7.H2,
    H2size: "text-6xl",
    fontP: Fonts.f7.fontP,
    ftPdf: `absolute top-0 right-0 w-full`,
    fbPdf: `absolute -bottom-20 left-0 w-2/3`,
    fcPdf: `z-10 text-center p-20 w-full text-black space-y-8 h-full flex flex-col justify-center`,tStyle: `text-center p-20 md:px-20 md:py-10 border border-black`,
    H2Pdf: "text-4xl",
    whiteBg: "p-2 mx-4 bg-white opacity-80 z-10 rounded-lg",
  },
  theme100: {
    bg: '',
    ft: `${process.env.REACT_APP_THEMES_URL}/ft100.png`,
    fb: `${process.env.REACT_APP_THEMES_URL}/fb100.png`,
    fc: `${process.env.REACT_APP_THEMES_URL}/fc100.png`,
    ftStyle: `absolute top-0 left-50 w-full sm:-top-32 md:-top-60`,
    fbStyle: `absolute bottom-0 right-50 w-full sm:-bottom-32 md:-bottom-60`,
    fcStyle: `text-center p-20 md:p-44 w-full sm:w-full text-stone-100 space-y-16 sm:space-y-28 md:space-y-8 flex flex-col justify-center`,
    tStyle: `text-center p-10 md:px-20 md:py-10 border border-stone-100`,
    xTopStyle: -100,
    xBottomStyle: 100,
    centerText: `text-stone-100`,
    textColor: `text-stone-100`,
    themeColor: 'bg-stone-900',
    cd1: "bg-stone-200 p-4 rounded-lg",
    cd2: "bg-stone-300 p-4 rounded-lg",
    cd3: "bg-stone-400 p-4 rounded-lg",
    cd4: "bg-stone-500 p-4 rounded-lg",
    H2: Fonts.f13.H2,
    H2size: "text-4xl sm:text-6xl",
    fontP: Fonts.f13.fontP,
    ftPdf: `absolute top-0 left-50 w-full`,
    fbPdf: `absolute bottom-0 right-50 w-full`,
    fcPdf: `text-center p-20 w-full text-stone-100 space-y-16 flex flex-col justify-center`,
    H2Pdf: "text-4xl",
    whiteBg: "p-2 mx-4 bg-stone-900 opacity-80 z-10 rounded-lg",
  },
};

export default themes;
